"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.visualizeCentralConnectorForOnePairOfSlots = exports.visualizeAnchorFastenerForOnePairOfSlots = exports.visualizeGroupAFastenerForOnePairOfSlots = exports.visualizeMillingAndTMaticConnectorForOnePairOfSlots = exports.visualizeInnerConnectorForOnePairOfSlots = exports.visualizePlateConnectorForOnePairOfSlots = exports.rotateFastenerForEndGroupVisualization = exports.rotateFastenerForGroupAVisualization = exports.validateIfScrewCombinationFastenerCanBePlace = exports.validateIfZeroDegreeCentralConnectorsCanBePlace = exports.validateIfSocketHeadCapScrewsCanBePlaced = exports.validateIfEndToEndFastenersCanBePlaced = exports.validateIfFastenersForEndGroupCanBePlaced = exports.validateIfFastenersOfScrewGroupCanBePlaced = exports.validateIfPlateConnectorsCanBePlaced = exports.validateIfFastenersOfDoubleAnchorGroupCanBePlaced = exports.validateIfFastenersOfAGroupCanBePlaced = exports.isExistProjectedInterferenceForOppositeSide = exports.getMainAndConnectedExtrusionForEndToEndSnapping = exports.getMainAndConnectedExtrusionForPerpendicularSnapping = exports.tryToVisualizeFastenersForPanelToExtrusionSideConnection = exports.tryToVisualizeFastenersForComponentToPanelConnection = exports.tryToVisualizeFastenersForComponentConnection = exports.calculatePanelFastenerPoints = exports.getSlotClosestToPanelEdge = exports.setFastenerTransformation = exports.createConnectionSphere = exports.getUUIDsOfExtrusionsConnectedToObject = exports.getConnectionTypeBetweenExtrusions = exports.getConnectionTypeBetweenPanelAndExtrusion = exports.getConnectedFace = exports.areComponentAndExtrusionCompatibleByTap = exports.checkMountToAndSeriesCompatibility = exports.getSnappingData = exports.checkIfPanelSnappedToExtrusionSide = exports.checkIfPanelSnappedToExtrusionSlot = exports.getComponentToPanelSnapData = exports.getComponentToComponentSnapData = exports.getExtrusionToComponentSnapData = exports.getExtrusionToExtrusionSnapData = exports.getCoverToExtrusionSnapData = exports.areObjectsSnapped = exports.areComponentsSnapped = exports.areExtrusionAndComponentOrPanelSnapped = exports.areExtrusionsSnapped = exports.areComponentAndPanelSnapped = exports.findSnappingPointsFittedToPanel = exports.findFittedSnappingPoints = exports.findSnappingToSlots = exports.getEmptySnappingData = void 0;
exports.getConnectionMetadataByFastenersPosition = exports.tryToFlipFasteners = exports.checkIfFastenersInConnectionCanBeFlipped = exports.checkIfSimilarFastenersCanBeFlipped = exports.checkIfEndToEndFastenersCanBeFlipped = exports.getSlotsOnExtrusionByFastenerPosition = exports.onAfterAddOrShowPlateConnector = exports.onBeforeRemoveOrHidePlateConnector = exports.getApplicableFastenerTypes = exports.getApplicableFastenerTypesForEndToEndExtrusions = exports.getApplicableFastenerTypesForAngledExtrusions = exports.getApplicableFastenerTypesForPerpendicularExtrusions = exports.isObjectSnapped = exports.addSphereToConnection = exports.tryToVisualizeFasteners = exports.tryToVisualizeCombinedFasteners = exports.tryToVisualizeGasket = exports.tryToVisualizeFastenersForAngledExtrusions = exports.tryToVisualizeFastenersForEndToEndConnection = exports.tryToVisualizeFastenersForPerpendicularExtrusions = exports.visualizeScrewCombinationFasteners = exports.visualizeZeroDegreesConnector = exports.visualizeSocketHeadCapScrews = exports.visualizeEndToEndFasteners = exports.visualizeEndToEndFastenerForOnePairOfSlots = exports.visualizeFastenerForEndGroup = exports.visualizeDoubleEndFasteners = exports.visualizeFastenerForAandDoubleAnchorGroupsAndPlateConnectors = exports.visualizeScrewCombinationFastenerForOnePairOfSlots = exports.visualizeDoubleEndFastenerForOneConnection = exports.visualizeSocketHeadCapScrewForOneConnection = exports.visualizeEndFastenerGroupForOneConnection = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
const three_1 = require("three");
const OBB_js_1 = require("three/examples/jsm/math/OBB.js");
const types_1 = require("~/store/types");
const Utils = __importStar(require("./utils.3d"));
const consts_1 = require("../consts");
const Viewer_1 = __importDefault(require("../Viewer"));
const utils_3d_1 = require("./utils.3d");
const consts_2 = require("../consts/consts");
const ConnectionManager_3d_1 = __importDefault(require("../classes/ConnectionManager.3d"));
const GasketInSlotSnapping_1 = __importDefault(require("../classes/SlotCoverSnapping/GasketInSlotSnapping"));
const PanelInSlotsUtils_1 = require("../classes/PanelInSlots/PanelInSlotsUtils");
const tempVector = new three_1.Vector3();
const tempVector2 = new three_1.Vector3();
const tempQuaternion = new three_1.Quaternion();
const tempPlane = new three_1.Plane();
const extrusionSlot = 'Extrusion slot';
const otherComponents = 'Other components';
function getEmptySnappingData(mountedObject, neighborObject) {
    return {
        slotNumbers: [],
        numberOfSnappedSnappingPoints: 0,
        mountedObjectPointsIndices: [],
        snapped: false,
        mountToType: null,
        mountedObject,
        neighborObject,
    };
}
exports.getEmptySnappingData = getEmptySnappingData;
function findSnappingToSlots(points, slots, type) {
    const result = {
        slots: [],
        snappingPoints: [],
        snappingPointsIndices: [],
        snapped: false,
    };
    if (!(points === null || points === void 0 ? void 0 : points.length) || !(slots === null || slots === void 0 ? void 0 : slots.length)) {
        return result;
    }
    const slotOBB = new OBB_js_1.OBB();
    // eslint-disable-next-line no-restricted-syntax
    for (const slot of slots) {
        let slotSnapped = false;
        Utils.getOBBofSlotSurface(slot, slotOBB).clone();
        // TODO: refactor this loop to be functional-like
        // eslint-disable-next-line no-restricted-syntax
        for (const [pointIndex, point] of points.entries()) {
            const pointOrigin = point instanceof three_1.Vector3 ? point : point.origin;
            const pointNormal = point instanceof three_1.Vector3 ? utils_3d_1.zeroVector : point.normal;
            const areNormalsOpposite = Utils.areVectorsEqual(pointNormal, slot.normal.clone().negate(), consts_1.consts.THREE_FLOAT_EPSILON) ||
                Utils.areVectorsEqual(pointNormal, utils_3d_1.zeroVector, consts_1.consts.THREE_FLOAT_EPSILON);
            if (slotOBB.containsPoint(pointOrigin) && areNormalsOpposite) {
                result.snapped = true;
                if (type === 'onlyCheckIfSnappingExists') {
                    return result;
                }
                slotSnapped = true;
                if (type === 'findSlots') {
                    break;
                }
                result.snappingPoints.push(pointOrigin);
                result.snappingPointsIndices.push(pointIndex);
            }
        }
        if (slotSnapped) {
            result.slots.push(slot);
        }
    }
    return result;
}
exports.findSnappingToSlots = findSnappingToSlots;
function findFittedSnappingPoints(inboundSnappingPoints, outboundSnappingPoints, type) {
    if (!(inboundSnappingPoints === null || inboundSnappingPoints === void 0 ? void 0 : inboundSnappingPoints.length) || !(outboundSnappingPoints === null || outboundSnappingPoints === void 0 ? void 0 : outboundSnappingPoints.length)) {
        return { points: [], inboundPointsIndices: [], snapped: false };
    }
    const result = {
        points: [],
        inboundPointsIndices: [],
        snapped: false,
    };
    // eslint-disable-next-line no-restricted-syntax
    for (const pointToFitOn of outboundSnappingPoints) {
        const pointToFitOnOrigin = pointToFitOn instanceof three_1.Vector3 ? pointToFitOn : pointToFitOn.origin;
        const pointToFitOnNormal = pointToFitOn instanceof three_1.Vector3 ? utils_3d_1.zeroVector : pointToFitOn.normal;
        // eslint-disable-next-line no-restricted-syntax
        for (const [pointIndex, point] of inboundSnappingPoints.entries()) {
            const pointOrigin = point instanceof three_1.Vector3 ? point : point.origin;
            const pointNormal = point instanceof three_1.Vector3 ? utils_3d_1.zeroVector : point.normal;
            const areNormalsOpposite = Utils.areVectorsEqual(pointNormal, pointToFitOnNormal.clone().negate()) ||
                Utils.areVectorsEqual(pointNormal, utils_3d_1.zeroVector) ||
                Utils.areVectorsEqual(pointToFitOnNormal, utils_3d_1.zeroVector);
            if (pointOrigin.distanceTo(pointToFitOnOrigin) < consts_1.consts.MAX_SLOT_DETECTION_DISTANCE && areNormalsOpposite) {
                if (type === 'onlyCheckIfSnappingExists') {
                    result.snapped = true;
                    return result;
                }
                result.points.push(pointToFitOn);
                result.inboundPointsIndices.push(pointIndex);
                result.snapped = true;
            }
        }
    }
    return result;
}
exports.findFittedSnappingPoints = findFittedSnappingPoints;
function findSnappingPointsFittedToPanel(panel, snappingPoints, type) {
    if (!snappingPoints.length) {
        return { snappingPoints: [], snappingPointsIndices: [], snapped: false };
    }
    const result = {
        snappingPoints: [],
        snappingPointsIndices: [],
        snapped: false,
    };
    const extendedPanelBBox = Utils.getAABBox(panel).expandByVector(Utils.absVector(panel.directionNormal.clone().multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE)));
    // eslint-disable-next-line no-restricted-syntax
    for (const [pointIndex, point] of snappingPoints.entries()) {
        if (Utils.areVectorsCollinear(panel.directionNormal, point.normal) &&
            extendedPanelBBox.containsPoint(point.origin)) {
            result.snapped = true;
            if (type === 'onlyCheckIfSnappingExists') {
                return result;
            }
            result.snappingPoints.push(point);
            result.snappingPointsIndices.push(pointIndex);
        }
    }
    return result;
}
exports.findSnappingPointsFittedToPanel = findSnappingPointsFittedToPanel;
function areComponentAndPanelSnapped(object, panel) {
    const objectBbox = Utils.getAABBox(object);
    const panelBBox = Utils.getAABBox(panel);
    objectBbox.expandByVector(Utils.absVector(tempVector.copy(panel.directionNormal)).setLength(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE));
    return (objectBbox.intersectsBox(panelBBox) &&
        Utils.isObjectCoveredByNeighbor(Utils.getAABBox(object), panelBBox, panel.directionNormal));
}
exports.areComponentAndPanelSnapped = areComponentAndPanelSnapped;
function areExtrusionsSnapped(firstObject, secondObject) {
    var _a, _b, _c, _d, _e, _f;
    const firstObjectSlots = (_a = firstObject.getSlots()) !== null && _a !== void 0 ? _a : [];
    const secondObjectSlots = (_b = secondObject.getSlots()) !== null && _b !== void 0 ? _b : [];
    return (findFittedSnappingPoints((_c = firstObject.getInboundSnappingPoints()) !== null && _c !== void 0 ? _c : [], (_d = secondObject.getInboundSnappingPoints()) !== null && _d !== void 0 ? _d : [], 'onlyCheckIfSnappingExists').snapped ||
        findSnappingToSlots((_e = firstObject.getInboundSnappingPoints()) !== null && _e !== void 0 ? _e : [], secondObjectSlots, 'onlyCheckIfSnappingExists')
            .snapped ||
        findSnappingToSlots((_f = secondObject.getInboundSnappingPoints()) !== null && _f !== void 0 ? _f : [], firstObjectSlots, 'onlyCheckIfSnappingExists')
            .snapped);
}
exports.areExtrusionsSnapped = areExtrusionsSnapped;
function areExtrusionAndComponentOrPanelSnapped(extrusion, component) {
    var _a, _b, _c, _d;
    const slots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
    return (findFittedSnappingPoints((_b = extrusion.getInboundSnappingPoints()) !== null && _b !== void 0 ? _b : [], (_c = component.getInboundSnappingPoints()) !== null && _c !== void 0 ? _c : [], 'onlyCheckIfSnappingExists').snapped ||
        findSnappingToSlots((_d = component.getInboundSnappingPoints()) !== null && _d !== void 0 ? _d : [], slots, 'onlyCheckIfSnappingExists').snapped);
}
exports.areExtrusionAndComponentOrPanelSnapped = areExtrusionAndComponentOrPanelSnapped;
function areComponentsSnapped(firstComponent, secondComponent) {
    var _a, _b, _c, _d;
    return (findFittedSnappingPoints((_a = firstComponent.getInboundSnappingPoints()) !== null && _a !== void 0 ? _a : [], (_b = secondComponent.getOutboundSnappingPoints()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped ||
        findFittedSnappingPoints((_c = secondComponent.getInboundSnappingPoints()) !== null && _c !== void 0 ? _c : [], (_d = firstComponent.getOutboundSnappingPoints()) !== null && _d !== void 0 ? _d : [], 'onlyCheckIfSnappingExists').snapped);
}
exports.areComponentsSnapped = areComponentsSnapped;
function areExtrusionAndCoverSnapped(firstObject, secondObject) {
    var _a, _b;
    const cover = Utils.isCoverComponent(firstObject) ? firstObject : secondObject;
    const extrusion = cover === firstObject ? secondObject : firstObject;
    const slots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
    const masterSnappingPoint = (_b = cover.getMasterSnappingPoints()) === null || _b === void 0 ? void 0 : _b[0];
    if (!masterSnappingPoint) {
        return { slots: [], snappingPoints: [], snappingPointsIndices: [], snapped: false };
    }
    return findSnappingToSlots([masterSnappingPoint], slots, 'onlyCheckIfSnappingExists').snapped;
}
function areObjectsSnapped(firstObject, secondObject) {
    if (!firstObject.hasSnappingMetadata || !secondObject.hasSnappingMetadata) {
        return false;
    }
    if (Utils.isCoverComponent(firstObject) || Utils.isCoverComponent(secondObject)) {
        if (Utils.isCoverAndExtrusionPair(firstObject, secondObject)) {
            return areExtrusionAndCoverSnapped(firstObject, secondObject);
        }
        return false;
    }
    if (firstObject.type === 'Extrusion' && secondObject.type === 'Extrusion') {
        return areExtrusionsSnapped(firstObject, secondObject);
    }
    if (firstObject.type === 'Extrusion') {
        return areExtrusionAndComponentOrPanelSnapped(firstObject, secondObject);
    }
    if (secondObject.type === 'Extrusion') {
        return areExtrusionAndComponentOrPanelSnapped(secondObject, firstObject);
    }
    if (firstObject.type === 'Component' && secondObject.type === 'Component') {
        return areComponentsSnapped(firstObject, secondObject);
    }
    if (firstObject.type === 'Component' && secondObject.type === 'Panel') {
        return areComponentAndPanelSnapped(firstObject, secondObject);
    }
    if (firstObject.type === 'Panel' && secondObject.type === 'Component') {
        return areComponentAndPanelSnapped(secondObject, firstObject);
    }
    return false;
}
exports.areObjectsSnapped = areObjectsSnapped;
function getCoverToExtrusionSnapData(firstObject, secondObject) {
    var _a, _b;
    const cover = Utils.isCoverComponent(firstObject) ? firstObject : secondObject;
    const extrusion = cover === firstObject ? secondObject : firstObject;
    const slots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
    const masterSnappingPoint = (_b = cover.getMasterSnappingPoints()) === null || _b === void 0 ? void 0 : _b[0];
    if (!masterSnappingPoint) {
        return getEmptySnappingData(firstObject, secondObject);
    }
    const result = findSnappingToSlots([masterSnappingPoint], slots, 'onlyCheckIfSnappingExists');
    if (result.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result.snappingPoints.length,
            mountedObjectPointsIndices: [],
            slotNumbers: result.slots.map((slot) => slot.slotNumber),
            mountToType: extrusionSlot,
            mountedObject: cover,
            neighborObject: extrusion,
        };
    }
    return getEmptySnappingData(firstObject, secondObject);
}
exports.getCoverToExtrusionSnapData = getCoverToExtrusionSnapData;
function getExtrusionToExtrusionSnapData(firstObject, secondObject) {
    var _a, _b, _c, _d, _e, _f;
    let mainObject = firstObject;
    let connectedObject = secondObject;
    const connectionObjectBetweenObjects = Viewer_1.default.instance
        .getDesignProMain()
        .connectionManager.findConnectionObjectBetween(firstObject.uuid, secondObject.uuid);
    if ((connectionObjectBetweenObjects === null || connectionObjectBetweenObjects === void 0 ? void 0 : connectionObjectBetweenObjects.getMainObject()) === connectedObject) {
        const temp = mainObject;
        mainObject = connectedObject;
        connectedObject = temp;
    }
    const result1 = findFittedSnappingPoints((_a = connectedObject.getInboundSnappingPoints()) !== null && _a !== void 0 ? _a : [], (_b = mainObject.getInboundSnappingPoints()) !== null && _b !== void 0 ? _b : [], 'findSnappingPoints');
    if (result1.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result1.points.length,
            mountedObjectPointsIndices: result1.inboundPointsIndices,
            slotNumbers: [],
            mountToType: 'Extrusion end',
            mountedObject: mainObject,
            neighborObject: connectedObject,
        };
    }
    const firstObjectSlots = (_c = firstObject.getSlots()) !== null && _c !== void 0 ? _c : [];
    const secondObjectSlots = (_d = secondObject.getSlots()) !== null && _d !== void 0 ? _d : [];
    const result2 = findSnappingToSlots((_e = firstObject.getInboundSnappingPoints()) !== null && _e !== void 0 ? _e : [], secondObjectSlots, 'findBoth');
    if (result2.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result2.snappingPoints.length,
            mountedObjectPointsIndices: result2.snappingPointsIndices,
            slotNumbers: result2.slots.map((slot) => slot.slotNumber),
            mountToType: extrusionSlot,
            mountedObject: firstObject,
            neighborObject: secondObject,
        };
    }
    const result3 = findSnappingToSlots((_f = secondObject.getInboundSnappingPoints()) !== null && _f !== void 0 ? _f : [], firstObjectSlots, 'findBoth');
    if (result3.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result3.snappingPoints.length,
            mountedObjectPointsIndices: result3.snappingPointsIndices,
            slotNumbers: result3.slots.map((slot) => slot.slotNumber),
            mountToType: extrusionSlot,
            mountedObject: secondObject,
            neighborObject: firstObject,
        };
    }
    return getEmptySnappingData(firstObject, secondObject);
}
exports.getExtrusionToExtrusionSnapData = getExtrusionToExtrusionSnapData;
function getExtrusionToComponentSnapData(extrusion, component) {
    var _a, _b, _c, _d;
    const slots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
    const result1 = findFittedSnappingPoints((_b = component.getInboundSnappingPoints()) !== null && _b !== void 0 ? _b : [], (_c = extrusion.getInboundSnappingPoints()) !== null && _c !== void 0 ? _c : [], 'findSnappingPoints');
    if (result1.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result1.points.length,
            mountedObjectPointsIndices: result1.inboundPointsIndices,
            slotNumbers: [],
            mountToType: 'Extrusion end',
            mountedObject: component,
            neighborObject: extrusion,
        };
    }
    const result2 = findSnappingToSlots((_d = component.getInboundSnappingPoints()) !== null && _d !== void 0 ? _d : [], slots, 'findBoth');
    if (result2.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result2.snappingPoints.length,
            mountedObjectPointsIndices: result2.snappingPointsIndices,
            slotNumbers: result2.slots.map((slot) => slot.slotNumber),
            mountToType: extrusionSlot,
            mountedObject: component,
            neighborObject: extrusion,
        };
    }
    return getEmptySnappingData(component, extrusion);
}
exports.getExtrusionToComponentSnapData = getExtrusionToComponentSnapData;
function getComponentToComponentSnapData(firstComponent, secondComponent) {
    var _a, _b, _c, _d;
    const result1 = findFittedSnappingPoints((_a = firstComponent.getInboundSnappingPoints()) !== null && _a !== void 0 ? _a : [], (_b = secondComponent.getOutboundSnappingPoints()) !== null && _b !== void 0 ? _b : [], 'findSnappingPoints');
    if (result1.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result1.points.length,
            mountedObjectPointsIndices: result1.inboundPointsIndices,
            slotNumbers: [],
            mountToType: otherComponents,
            mountedObject: firstComponent,
            neighborObject: secondComponent,
        };
    }
    const result2 = findFittedSnappingPoints((_c = secondComponent.getInboundSnappingPoints()) !== null && _c !== void 0 ? _c : [], (_d = firstComponent.getOutboundSnappingPoints()) !== null && _d !== void 0 ? _d : [], 'findSnappingPoints');
    if (result2.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result2.points.length,
            mountedObjectPointsIndices: result2.inboundPointsIndices,
            slotNumbers: [],
            mountToType: otherComponents,
            mountedObject: secondComponent,
            neighborObject: firstComponent,
        };
    }
    return getEmptySnappingData(firstComponent, secondComponent);
}
exports.getComponentToComponentSnapData = getComponentToComponentSnapData;
function getComponentToPanelSnapData(component, panel) {
    var _a;
    const result = findSnappingPointsFittedToPanel(panel, (_a = component.getInboundSnappingPoints()) !== null && _a !== void 0 ? _a : [], 'findSnappingPoints');
    if (result.snapped) {
        return {
            snapped: true,
            numberOfSnappedSnappingPoints: result.snappingPoints.length,
            mountedObjectPointsIndices: result.snappingPointsIndices,
            slotNumbers: [],
            mountToType: 'Panel',
            mountedObject: component,
            neighborObject: panel,
        };
    }
    return getEmptySnappingData(component, panel);
}
exports.getComponentToPanelSnapData = getComponentToPanelSnapData;
function checkIfPanelSnappedToExtrusionSlot(panel, extrusion) {
    var _a;
    if (!(0, utils_3d_1.areVectorsPerpendicular)(panel.directionNormal, extrusion.directionNormal)) {
        return [false, []];
    }
    const alignedSlots = (_a = extrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.filter((slot) => {
        return ((0, utils_3d_1.areVectorsPerpendicular)(panel.directionNormal, slot.normal) &&
            Utils.areEqual((0, utils_3d_1.getAABBoxCenter)(panel).sub(slot.origin).dot(panel.directionNormal), 0.0, consts_1.consts.TWO_FLOAT_EPSILON));
    });
    if (!(alignedSlots === null || alignedSlots === void 0 ? void 0 : alignedSlots.length)) {
        return [false, []];
    }
    const cutContour = panel.getTransformedCutContour();
    const extrusionOBB = (0, utils_3d_1.getOBB)(extrusion);
    let doesConnectedEdgeExist = false;
    const connectedSlots = [];
    cutContour.forEach((point, pointIndex) => {
        const nextPointIndex = pointIndex < cutContour.length - 1 ? pointIndex + 1 : 0;
        const nextPoint = cutContour[nextPointIndex];
        if (Utils.intersectsLineSegment(extrusionOBB, point, nextPoint)) {
            const connectedSlot = alignedSlots.find((slot) => {
                const slotPoint = tempVector.addVectors(slot.surfacePoint, tempVector2.copy(slot.normal).negate().multiplyScalar(slot.depth));
                const slotPlane = tempPlane.setFromNormalAndCoplanarPoint(slot.normal, slotPoint);
                return (Utils.areEqual(slotPlane.distanceToPoint(point), 0) && Utils.areEqual(slotPlane.distanceToPoint(nextPoint), 0));
            });
            if (connectedSlot) {
                doesConnectedEdgeExist = true;
                connectedSlots.push(connectedSlot);
            }
        }
    });
    const snapped = doesConnectedEdgeExist;
    const connectedSlotNumbers = snapped ? [...new Set(connectedSlots.map((slot) => slot.slotNumber))] : [];
    return [snapped, connectedSlotNumbers];
}
exports.checkIfPanelSnappedToExtrusionSlot = checkIfPanelSnappedToExtrusionSlot;
function checkIfPanelSnappedToExtrusionSide(panel, extrusion) {
    var _a;
    if (panel.isWireMesh() ||
        (0, utils_3d_1.isAngledExtrusion)(extrusion) ||
        !(0, utils_3d_1.areVectorsPerpendicular)(panel.directionNormal, extrusion.directionNormal)) {
        return [false, []];
    }
    const panelBBox = (0, utils_3d_1.getAABBox)(panel);
    const extrusionBBox = (0, utils_3d_1.getAABBox)(extrusion);
    if ((0, utils_3d_1.expandBBox)(panelBBox, panel.directionNormal, -consts_1.consts.MAX_SLOT_DETECTION_DISTANCE).intersectsBox(extrusionBBox)) {
        return [false, []];
    }
    const snappedSlotsNumbers = [];
    const slotBBox = new three_1.Box3();
    const intersectionBBox = new three_1.Box3();
    const intersectionBBoxSize = new three_1.Vector3();
    const alongWidthVector = new three_1.Vector3();
    (_a = extrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.forEach((slot) => {
        const slotNormal = slot.normal;
        if (!(0, utils_3d_1.areVectorsCollinear)(panel.directionNormal, slotNormal)) {
            return;
        }
        const surfacePoints = slot.points.map((point) => extrusionBBox.clampPoint(tempVector.copy(point).add(slotNormal), new three_1.Vector3()));
        slotBBox.setFromPoints(surfacePoints);
        intersectionBBox.copy((0, utils_3d_1.expandBBox)(panelBBox, panel.directionNormal, consts_1.consts.MAX_SLOT_DETECTION_DISTANCE));
        intersectionBBox.intersect(slotBBox).getSize(intersectionBBoxSize);
        alongWidthVector.crossVectors(slot.direction, slotNormal);
        (0, utils_3d_1.absVector)(alongWidthVector);
        if ((0, utils_3d_1.areEqual)(intersectionBBoxSize.dot(alongWidthVector), slotBBox.getSize(tempVector).dot(alongWidthVector))) {
            snappedSlotsNumbers.push(slot.slotNumber);
        }
    });
    return [snappedSlotsNumbers.length > 0, snappedSlotsNumbers];
}
exports.checkIfPanelSnappedToExtrusionSide = checkIfPanelSnappedToExtrusionSide;
function getSnappingData(firstObject, secondObject) {
    if (!firstObject.hasSnappingMetadata || !secondObject.hasSnappingMetadata) {
        return getEmptySnappingData(firstObject, secondObject);
    }
    if (Utils.isCoverComponent(firstObject) || Utils.isCoverComponent(secondObject)) {
        if (Utils.isCoverAndExtrusionPair(firstObject, secondObject)) {
            return getCoverToExtrusionSnapData(firstObject, secondObject);
        }
        return getEmptySnappingData(firstObject, secondObject);
    }
    if (firstObject.type === 'Extrusion' && secondObject.type === 'Extrusion') {
        return getExtrusionToExtrusionSnapData(firstObject, secondObject);
    }
    if (firstObject.type === 'Extrusion' && secondObject.type === 'Component') {
        return getExtrusionToComponentSnapData(firstObject, secondObject);
    }
    if (secondObject.type === 'Extrusion' && firstObject.type === 'Component') {
        return getExtrusionToComponentSnapData(secondObject, firstObject);
    }
    if (firstObject.type === 'Component' && secondObject.type === 'Component') {
        return getComponentToComponentSnapData(firstObject, secondObject);
    }
    if (firstObject.type === 'Component' && secondObject.type === 'Panel') {
        return getComponentToPanelSnapData(firstObject, secondObject);
    }
    if (firstObject.type === 'Panel' && secondObject.type === 'Component') {
        return getComponentToPanelSnapData(secondObject, firstObject);
    }
    if (firstObject.type === 'Extrusion' && secondObject.type === 'Panel') {
        const temp = firstObject;
        firstObject = secondObject;
        secondObject = temp;
    }
    if (firstObject.type === 'Panel' && secondObject.type === 'Extrusion') {
        let [snapped, slotNumbers] = checkIfPanelSnappedToExtrusionSide(firstObject, secondObject);
        if (!snapped) {
            [snapped, slotNumbers] = checkIfPanelSnappedToExtrusionSlot(firstObject, secondObject);
        }
        return {
            snapped,
            numberOfSnappedSnappingPoints: 0,
            mountedObjectPointsIndices: [],
            slotNumbers,
            mountToType: null,
            mountedObject: firstObject,
            neighborObject: secondObject,
        };
    }
    return getEmptySnappingData(firstObject, secondObject);
}
exports.getSnappingData = getSnappingData;
function checkMountToAndSeriesCompatibility(activeObject, neighborObject, mountToType) {
    if (!Utils.areSeriesCompatible(activeObject, neighborObject)) {
        return false;
    }
    const mountToObjects = activeObject.partDetails.mountTo.filter((value) => value.type === mountToType);
    if (!mountToObjects) {
        return false;
    }
    if (mountToType !== otherComponents) {
        return true;
    }
    for (const object of mountToObjects) {
        if (object.mountToItems.map((item) => item.item_number).includes(neighborObject.partDetails.itemNumber)) {
            return true;
        }
    }
    return false;
}
exports.checkMountToAndSeriesCompatibility = checkMountToAndSeriesCompatibility;
function areComponentAndExtrusionCompatibleByTap(component, extrusion) {
    var _a;
    const isFootOrStemCaster = Utils.isFoot(component) || Utils.isStemCaster(component);
    return !isFootOrStemCaster || ((_a = component.compatibleExtrusions) === null || _a === void 0 ? void 0 : _a.includes(extrusion.partDetails.extrusionProfileType));
}
exports.areComponentAndExtrusionCompatibleByTap = areComponentAndExtrusionCompatibleByTap;
function getConnectedFace(object, snapPosition, isAngledConnection = false) {
    let connectedFace = null;
    if ((0, utils_3d_1.isExtrusion)(object)) {
        const distance = snapPosition.clone().sub(object.position).dot(object.directionNormal);
        connectedFace =
            (0, utils_3d_1.areEqual)(distance, object.getLength(), consts_1.consts.TWO_FLOAT_EPSILON) ||
                (0, utils_3d_1.areEqual)(distance, 0, consts_1.consts.TWO_FLOAT_EPSILON) ||
                isAngledConnection
                ? types_1.CONNECTED_FACE.END
                : types_1.CONNECTED_FACE.SIDE;
    }
    else if ((0, utils_3d_1.isPanel)(object)) {
        connectedFace = types_1.CONNECTED_FACE.SIDE;
    }
    return connectedFace;
}
exports.getConnectedFace = getConnectedFace;
function getConnectionTypeBetweenPanelAndExtrusion(panel, extrusion) {
    const panelBox = (0, utils_3d_1.getAABBox)(panel);
    const extrusionBox = (0, utils_3d_1.getAABBox)(extrusion);
    return (0, utils_3d_1.expandBBox)(panelBox, panel.directionNormal, -consts_1.consts.MAX_SLOT_DETECTION_DISTANCE).intersectsBox(extrusionBox)
        ? types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT
        : types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SIDE;
}
exports.getConnectionTypeBetweenPanelAndExtrusion = getConnectionTypeBetweenPanelAndExtrusion;
function getConnectionTypeBetweenExtrusions(firstExtrusion, secondExtrusion) {
    let connectionType;
    if ((0, utils_3d_1.areVectorsCollinear)(firstExtrusion.directionNormal, secondExtrusion.directionNormal)) {
        connectionType = types_1.CONNECTION_TYPE.END_TO_END;
    }
    else {
        connectionType = (0, utils_3d_1.areVectorsPerpendicular)(firstExtrusion.directionNormal, secondExtrusion.directionNormal)
            ? types_1.CONNECTION_TYPE.PERPENDICULAR
            : types_1.CONNECTION_TYPE.ANGLED;
    }
    return connectionType;
}
exports.getConnectionTypeBetweenExtrusions = getConnectionTypeBetweenExtrusions;
function getUUIDsOfExtrusionsConnectedToObject(object) {
    const result = [];
    object.connectedItems.forEach((connectedItem) => {
        if ((connectedItem === null || connectedItem === void 0 ? void 0 : connectedItem.itemType) === types_1.ITEM_TYPE.EXTRUSION) {
            result.push(connectedItem.uuid);
        }
    });
    return result;
}
exports.getUUIDsOfExtrusionsConnectedToObject = getUUIDsOfExtrusionsConnectedToObject;
function createConnectionSphere(sphereRadius, spherePosition) {
    const geometry = new three_1.SphereGeometry(sphereRadius, 32, 16);
    const material = new three_1.MeshBasicMaterial({
        color: consts_1.consts.TERRACOTTA_COLOR,
        alphaToCoverage: true,
        opacity: 0.75,
    });
    const sphere = new three_1.Mesh(geometry, material);
    sphere.position.copy(spherePosition);
    sphere.visible = false;
    return sphere;
}
exports.createConnectionSphere = createConnectionSphere;
/**
 * Set position and orientation for a given fastener. It is assumed that
 * the normal direction and the alignment axis (if any) are perpendicular.
 *
 * @returns the input fastener with the applied transformation.
 */
function setFastenerTransformation(fastener, position, normal, alignmentAxis) {
    var _a, _b;
    const xDirection = normal;
    const yDirection = alignmentAxis !== null && alignmentAxis !== void 0 ? alignmentAxis : Utils.invertVector(xDirection);
    const zDirection = tempVector.copy(xDirection).cross(yDirection);
    const currentBasis = fastener.getBasisMatrix();
    const requiredBasis = new three_1.Matrix4().makeBasis(xDirection, yDirection, zDirection);
    const deltaTransformation = requiredBasis.multiply(currentBasis.invert());
    fastener.applyMatrix4(deltaTransformation);
    const fastenerSnappingPoint = (_b = (_a = fastener.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : fastener.position;
    const positionOffset = tempVector.copy(position).sub(fastenerSnappingPoint);
    return fastener.translate(positionOffset);
}
exports.setFastenerTransformation = setFastenerTransformation;
/**
 * Find the slot closest to the panel edge.
 *
 * @slots an array of slots. All slots are assumed to have the same direction and normal.
 * @panelBBox axis-aligned bounding box of the panel.
 * @returns the slot closest to the panel edge if 'slots' is not empty array, undefined otherwise.
 */
function getSlotClosestToPanelEdge(slots, panelBBox) {
    if (!slots.length) {
        return undefined;
    }
    const [initialSlot] = slots;
    const projectionAxis = tempVector.copy(initialSlot.normal).cross(initialSlot.direction).normalize();
    const panelMinProjection = panelBBox.min.dot(projectionAxis);
    const panelMaxProjection = panelBBox.max.dot(projectionAxis);
    return slots.reduce((closestSlotData, currentSlot) => {
        const slotOriginProjection = currentSlot.origin.dot(projectionAxis);
        const minDistanceToPanelEdge = Math.min(Math.abs(slotOriginProjection - panelMinProjection), Math.abs(slotOriginProjection - panelMaxProjection));
        return minDistanceToPanelEdge < closestSlotData.distance
            ? { slot: currentSlot, distance: minDistanceToPanelEdge }
            : closestSlotData;
    }, {
        slot: initialSlot,
        distance: Infinity,
    }).slot;
}
exports.getSlotClosestToPanelEdge = getSlotClosestToPanelEdge;
function calculatePanelFastenerPointsPositions(intersectingAreaLength) {
    const thresholdLength = consts_1.consts.PANEL_INTERSECTING_AREA_THRESHOLD_LENGTH;
    const fastenerPointsPositions = [];
    if (Utils.areEqual(intersectingAreaLength, thresholdLength) || intersectingAreaLength > thresholdLength) {
        const edgeDistance = consts_1.consts.PANEL_FASTENER_EDGE_DISTANCE;
        const maxDistance = consts_1.consts.PANEL_FASTENERS_MAX_DISTANCE;
        const intersectingAreaLengthBetweenEdgeFasteners = intersectingAreaLength - 2 * edgeDistance;
        const fastenersCount = Math.ceil(Utils.roundTo3(intersectingAreaLengthBetweenEdgeFasteners / maxDistance)) + 1;
        const fastenersDistance = intersectingAreaLengthBetweenEdgeFasteners / (fastenersCount - 1);
        for (let fastenerIndex = 0; fastenerIndex < fastenersCount; fastenerIndex += 1) {
            fastenerPointsPositions.push(edgeDistance + fastenerIndex * fastenersDistance);
        }
    }
    else {
        fastenerPointsPositions.push(intersectingAreaLength / 2);
    }
    return fastenerPointsPositions;
}
function calculatePanelFastenerPoints(panel, extrusion, slot) {
    const panelBox = (0, utils_3d_1.getAABBox)(panel);
    const extrusionBox = (0, utils_3d_1.getAABBox)(extrusion);
    const expandingVector = Utils.absVector(tempVector.copy(slot.normal).multiplyScalar(consts_1.consts.THREE_FLOAT_EPSILON));
    extrusionBox.expandByVector(expandingVector);
    const intersectionArea = panelBox.intersect(extrusionBox);
    const bottomIntersectingAreaPoint = tempVector.copy(slot.surfacePoint);
    bottomIntersectingAreaPoint.add(tempVector2.copy(slot.normal).multiplyScalar(panel.getThickness() + consts_1.consts.THREE_FLOAT_EPSILON));
    const positiveSlotDirection = Utils.absVector(slot.direction.clone());
    const intersectionAreaMinProjection = intersectionArea.min.dot(positiveSlotDirection);
    const intersectionAreaMaxProjection = intersectionArea.max.dot(positiveSlotDirection);
    bottomIntersectingAreaPoint.multiply(Utils.invertVector(positiveSlotDirection));
    bottomIntersectingAreaPoint.add(tempVector2.copy(positiveSlotDirection).multiplyScalar(intersectionAreaMinProjection));
    const fastenerPointsPositions = calculatePanelFastenerPointsPositions(intersectionAreaMaxProjection - intersectionAreaMinProjection);
    return fastenerPointsPositions.map((pointPosition) => {
        return bottomIntersectingAreaPoint
            .clone()
            .add(tempVector2.copy(positiveSlotDirection).multiplyScalar(pointPosition));
    });
}
exports.calculatePanelFastenerPoints = calculatePanelFastenerPoints;
function tryToVisualizeFastenersForComponentConnection(mainObject, connectedObject, mainItem, connectedItem, fastenerPrototype) {
    const recommendedFastenerPoints = mainObject.getRecommendedFastenerPoints();
    const snappedPointsIndices = mainItem.snappedInboundPointsIndices;
    if (!(recommendedFastenerPoints === null || recommendedFastenerPoints === void 0 ? void 0 : recommendedFastenerPoints.length) || !(snappedPointsIndices === null || snappedPointsIndices === void 0 ? void 0 : snappedPointsIndices.length)) {
        return null;
    }
    if ((Utils.isPanelMountBlock(mainObject) || Utils.isPanelRetainer(mainObject)) && Utils.isPanel(connectedObject)) {
        return tryToVisualizeFastenersForComponentToPanelConnection(mainObject, connectedObject, snappedPointsIndices, fastenerPrototype);
    }
    const visualizedFasteners = snappedPointsIndices
        .map((pointIndex) => recommendedFastenerPoints[pointIndex])
        .filter(Boolean)
        .map((fastenerPoint) => {
        var _a;
        return setFastenerTransformation(fastenerPrototype.clone(), fastenerPoint.origin, (0, utils_3d_1.areVectorsNotEqual)(fastenerPoint.normal, utils_3d_1.zeroVector) ? fastenerPoint.normal : mainObject.directionNormal, ((_a = connectedItem.slotNumbers) === null || _a === void 0 ? void 0 : _a.length) ? connectedObject.directionNormal : undefined);
    });
    return { fasteners: visualizedFasteners };
}
exports.tryToVisualizeFastenersForComponentConnection = tryToVisualizeFastenersForComponentConnection;
function tryToVisualizeFastenersForComponentToPanelConnection(component, panel, snappedPointsIndices, fastenerPrototype) {
    const inboundSnappingPoints = component.getInboundSnappingPoints();
    const panelThickness = panel.getThickness();
    if (!(inboundSnappingPoints === null || inboundSnappingPoints === void 0 ? void 0 : inboundSnappingPoints.length)) {
        return null;
    }
    const visualizedFasteners = snappedPointsIndices
        .map((pointIndex) => inboundSnappingPoints[pointIndex])
        .filter(Boolean)
        .map((fastenerPoint) => setFastenerTransformation(fastenerPrototype.clone(), fastenerPoint.origin.clone().add(tempVector.copy(fastenerPoint.normal).multiplyScalar(panelThickness)), fastenerPoint.normal));
    return { fasteners: visualizedFasteners };
}
exports.tryToVisualizeFastenersForComponentToPanelConnection = tryToVisualizeFastenersForComponentToPanelConnection;
function tryToVisualizeFastenersForPanelToExtrusionSideConnection(panel, extrusion, slotNumbers, fastenerPrototype) {
    var _a, _b;
    const extrusionSlots = extrusion.getSlots();
    if (!extrusionSlots) {
        return null;
    }
    const connectedSlots = slotNumbers.reduce((slots, slotNumber) => {
        const connectedSlot = extrusionSlots.find((slot) => slot.slotNumber === slotNumber);
        if (connectedSlot) {
            slots.push(connectedSlot);
        }
        return slots;
    }, []);
    const closestSlot = getSlotClosestToPanelEdge(connectedSlots, (0, utils_3d_1.getAABBox)(panel));
    if (!closestSlot) {
        return null;
    }
    const fastenerPoints = calculatePanelFastenerPoints(panel, extrusion, closestSlot);
    if (!fastenerPoints.length) {
        return null;
    }
    // Find existing hardware (gussets, brackets, other connection fasteners) to prevent collision.
    // Exclude any fasteners belonging to the panel being connected so we don't collide with self.
    const existingGussetsAndFasteners = [];
    const otherExtrusions = [];
    const scene = (_b = (_a = Viewer_1.default.instance) === null || _a === void 0 ? void 0 : _a.getScene) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (scene) {
        scene.children.forEach((child) => {
            if (Utils.isConnection(child)) {
                const conn = child;
                if (conn.getMainObject() !== panel && conn.getConnectedObject() !== panel) {
                    existingGussetsAndFasteners.push(...conn.getFasteners());
                }
            }
            else if (child !== panel && child.parent !== panel && Utils.isComponent(child)) {
                existingGussetsAndFasteners.push(child);
            }
            else if (child.type === 'Extrusion' && child.uuid !== extrusion.uuid) {
                otherExtrusions.push(child);
            }
        });
    }
    const isFastenerColliding = (fastener) => {
        if (existingGussetsAndFasteners.some((existing) => existing !== fastener && fastener.testIntersection(existing))) {
            return true;
        }
        if (otherExtrusions.some((other) => fastener.testIntersection(other))) {
            return true;
        }
        return false;
    };
    const createFastenerAtPoint = (fastenerPoint) => {
        const fastener = setFastenerTransformation(fastenerPrototype.clone(), fastenerPoint, closestSlot.normal, extrusion.directionNormal);
        fastener.updateMatrixWorld(true);
        return fastener;
    };
    // 1. First evaluate default fastener points calculated along the slot.
    const primaryFastenerPoints = calculatePanelFastenerPoints(panel, extrusion, closestSlot);
    const visualizedFasteners = [];
    primaryFastenerPoints.forEach((point) => {
        const candidate = createFastenerAtPoint(point);
        if (!isFastenerColliding(candidate)) {
            visualizedFasteners.push(candidate);
        }
    });
    // 2. Even if some or all default points are blocked by intermediate extrusions/gussets,
    // search the open spans along the slot and add fasteners wherever possible.
    const panelBox = (0, utils_3d_1.getAABBox)(panel);
    const extrusionBox = (0, utils_3d_1.getAABBox)(extrusion);
    const expandingVector = Utils.absVector(tempVector.copy(closestSlot.normal).multiplyScalar(consts_1.consts.THREE_FLOAT_EPSILON));
    extrusionBox.expandByVector(expandingVector);
    const intersectionArea = panelBox.intersect(extrusionBox);
    const positiveSlotDirection = Utils.absVector(closestSlot.direction.clone());
    const intersectionAreaMinProjection = intersectionArea.min.dot(positiveSlotDirection);
    const intersectionAreaMaxProjection = intersectionArea.max.dot(positiveSlotDirection);
    const spanLength = intersectionAreaMaxProjection - intersectionAreaMinProjection;
    const edgeDistance = consts_1.consts.PANEL_FASTENER_EDGE_DISTANCE;
    const minFastenerDistance = 4; // minimum inches between fasteners
    if (spanLength > 2 * edgeDistance) {
        const bottomIntersectingAreaPoint = tempVector.copy(closestSlot.surfacePoint);
        bottomIntersectingAreaPoint.add(tempVector2.copy(closestSlot.normal).multiplyScalar(panel.getThickness() + consts_1.consts.THREE_FLOAT_EPSILON));
        bottomIntersectingAreaPoint.multiply(Utils.invertVector(positiveSlotDirection));
        bottomIntersectingAreaPoint.add(tempVector2.copy(positiveSlotDirection).multiplyScalar(intersectionAreaMinProjection));
        // If we have fewer fasteners than the primary points, or if none fit, test positions every 2 inches
        if (visualizedFasteners.length < primaryFastenerPoints.length || visualizedFasteners.length === 0) {
            for (let pos = edgeDistance; pos <= spanLength - edgeDistance + 0.01; pos += 2) {
                const testPoint = bottomIntersectingAreaPoint
                    .clone()
                    .add(tempVector2.copy(positiveSlotDirection).multiplyScalar(pos));
                const tooClose = visualizedFasteners.some((f) => f.position.distanceTo(testPoint) < minFastenerDistance);
                if (tooClose) {
                    continue;
                }
                const candidate = createFastenerAtPoint(testPoint);
                if (!isFastenerColliding(candidate)) {
                    visualizedFasteners.push(candidate);
                }
            }
        }
    }
    if (!visualizedFasteners.length) {
        return null;
    }
    return { fasteners: visualizedFasteners };
}
exports.tryToVisualizeFastenersForPanelToExtrusionSideConnection = tryToVisualizeFastenersForPanelToExtrusionSideConnection;
// connected extrusion is extrusion which is connected by its end face
function getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion) {
    var _a, _b;
    let mainExtrusion = firstExtrusion;
    let connectedExtrusion = secondExtrusion;
    if (findSnappingToSlots((_a = mainExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = connectedExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped) {
        const temp = mainExtrusion;
        mainExtrusion = connectedExtrusion;
        connectedExtrusion = temp;
    }
    return [mainExtrusion, connectedExtrusion];
}
exports.getMainAndConnectedExtrusionForPerpendicularSnapping = getMainAndConnectedExtrusionForPerpendicularSnapping;
function getMainAndConnectedExtrusionForEndToEndSnapping(firstExtrusion, secondExtrusion) {
    let mainObject = firstExtrusion;
    let connectedObject = secondExtrusion;
    const connectionObjectBetweenObjects = Viewer_1.default.instance
        .getDesignProMain()
        .connectionManager.findConnectionObjectBetween(firstExtrusion.uuid, secondExtrusion.uuid);
    if ((connectionObjectBetweenObjects === null || connectionObjectBetweenObjects === void 0 ? void 0 : connectionObjectBetweenObjects.getMainObject()) === connectedObject) {
        const temp = mainObject;
        mainObject = connectedObject;
        connectedObject = temp;
    }
    return [mainObject, connectedObject];
}
exports.getMainAndConnectedExtrusionForEndToEndSnapping = getMainAndConnectedExtrusionForEndToEndSnapping;
function isExistProjectedInterferenceForOppositeSide(mainExtrusion, connectedExtrusion) {
    const scene = Viewer_1.default.instance.getScene();
    const connectedItems = mainExtrusion.connectedItems
        .filter((connection) => connection.uuid !== connectedExtrusion.uuid)
        .map((connection) => Utils.getObjectByUUID(scene, connection.uuid))
        .filter((connection) => Utils.areVectorsCollinear(connection.directionNormal, connectedExtrusion.directionNormal));
    if (!connectedItems.length) {
        return false;
    }
    const connectedExtrusionPosition = Utils.getAABBoxCenter(connectedExtrusion);
    const mainExtrusionPosition = Utils.getAABBoxCenter(mainExtrusion);
    const distanceBetweenExtrusions = connectedExtrusion.directionNormal.dot(tempVector.subVectors(connectedExtrusionPosition, mainExtrusionPosition));
    tempVector
        .subVectors(mainExtrusionPosition, connectedExtrusionPosition)
        .projectOnVector(connectedExtrusion.directionNormal)
        .normalize();
    const oppositePosition = connectedExtrusionPosition.addScaledVector(tempVector, distanceBetweenExtrusions * 2);
    const oppositeConnectedBBox = Utils.getAABBox(connectedExtrusion.clone().setPosition(oppositePosition));
    oppositeConnectedBBox.expandByScalar(-consts_1.consts.COLLISION_PRECISION_DURING_SNAPPING);
    return connectedItems.some((connectedItem) => oppositeConnectedBBox.intersectsBox(Utils.getAABBox(connectedItem)));
}
exports.isExistProjectedInterferenceForOppositeSide = isExistProjectedInterferenceForOppositeSide;
function compareFunctionForSidesOfApplyingZeroDegreesCentralConnector(firstSide, secondSide, mainExtrusionBBox, fasteners) {
    if (firstSide.slotsOnConnectedExtrusion.length !== secondSide.slotsOnConnectedExtrusion.length) {
        return secondSide.slotsOnConnectedExtrusion.length - firstSide.slotsOnConnectedExtrusion.length;
    }
    const excludeCollisionUUIDs = new Set([
        firstSide.slotOnMainExtrusion.objectUUID,
        firstSide.slotsOnConnectedExtrusion[0].slot.objectUUID,
    ]);
    const [numberOfCollidedFastenersOnFirstSide, numberOfCollidedFastenersOnSecondSide] = [firstSide, secondSide].map((side) => side.slotsOnConnectedExtrusion.filter((slotDataOnConnectedExtrusion) => {
        const fastener = getFastenerBySlotNumber(fasteners, slotDataOnConnectedExtrusion.slot.slotNumber);
        if (!fastener || !fastener.getSecondSnappingPoint()) {
            return false;
        }
        const fastenerClone = fastener.clone();
        visualizeCentralConnectorForOnePairOfSlots(side.slotOnMainExtrusion, slotDataOnConnectedExtrusion.slot, fastenerClone, slotDataOnConnectedExtrusion.nearestSnappedSnappingPoint);
        Viewer_1.default.instance.getScene().add(fastenerClone);
        const collided = Viewer_1.default.instance.collisionProcessor.testCollisions(fastenerClone, Utils.getOBB(fastenerClone), {
            excludeIDs: excludeCollisionUUIDs,
            firstFoundCollisionOnly: true,
        }).result;
        fastenerClone.removeFromParent();
        return collided;
    }).length);
    const isFirstSideAligned = Utils.isSlotAlignedByBBox(firstSide.slotsOnConnectedExtrusion[0].slot, mainExtrusionBBox);
    const isSecondSideAligned = Utils.isSlotAlignedByBBox(secondSide.slotsOnConnectedExtrusion[0].slot, mainExtrusionBBox);
    if (numberOfCollidedFastenersOnFirstSide !== numberOfCollidedFastenersOnSecondSide) {
        return numberOfCollidedFastenersOnFirstSide - numberOfCollidedFastenersOnSecondSide;
    }
    if (isFirstSideAligned && !isSecondSideAligned) {
        return -1;
    }
    if (isSecondSideAligned && !isFirstSideAligned) {
        return 1;
    }
    let axes;
    if (Utils.areVectorsCollinear(firstSide.slotsOnConnectedExtrusion[0].slot.direction, consts_2.WORLD_AXES.Z)) {
        axes = consts_1.consts.PRIOR_AXES_FOR_SIDE_FOR_0_DEGREES_CENTRAL_CONNECTOR_WHILE_CONNECTED_EXTRUSION_PARALLEL_TO_Z;
    }
    else {
        axes = consts_1.consts.PRIOR_AXES_FOR_SIDE_FOR_0_DEGREES_CENTRAL_CONNECTOR_WHILE_CONNECTED_EXTRUSION_PERPENDICULAR_TO_Z;
    }
    const normalOfFirstSide = firstSide.slotsOnConnectedExtrusion[0].slot.normal;
    const normalOfSecondSide = secondSide.slotsOnConnectedExtrusion[0].slot.normal;
    let priorityOfFirstSide = axes.findIndex((axis) => Utils.areVectorsEqual(axis, normalOfFirstSide));
    let priorityOfSecondSide = axes.findIndex((axis) => Utils.areVectorsEqual(axis, normalOfSecondSide));
    priorityOfFirstSide = priorityOfFirstSide === -1 ? 100 : priorityOfFirstSide;
    priorityOfSecondSide = priorityOfSecondSide === -1 ? 100 : priorityOfSecondSide;
    return priorityOfFirstSide - priorityOfSecondSide;
}
function checkIfInnerConnectorAlignedByBBoxToMainExtrusion(fastenerBbox, mainExtrusionBBox, connectedExtrusionDirectionNormal) {
    const mainExtrusionProjectedBBox = mainExtrusionBBox;
    mainExtrusionProjectedBBox.min.projectOnPlane(connectedExtrusionDirectionNormal);
    mainExtrusionProjectedBBox.max.projectOnPlane(connectedExtrusionDirectionNormal);
    fastenerBbox.min.projectOnPlane(connectedExtrusionDirectionNormal);
    fastenerBbox.max.projectOnPlane(connectedExtrusionDirectionNormal);
    mainExtrusionProjectedBBox.expandByVector(Utils.absVector(tempVector.copy(connectedExtrusionDirectionNormal)));
    return mainExtrusionProjectedBBox.containsBox(fastenerBbox);
}
function selectSideSlotsForGroupA(availableSlots, mainExtrusion, connectedExtrusion, fasteners) {
    const firstSideConnectedExtrusionSlotNormal = availableSlots[0][1][0].normal;
    const firstSide = [];
    const secondSide = [];
    availableSlots.forEach((pair) => {
        pair[1].forEach((slotOnConnectedExtrusion) => {
            if (Utils.areVectorsEqual(slotOnConnectedExtrusion.normal, firstSideConnectedExtrusionSlotNormal)) {
                firstSide.push([pair[0], slotOnConnectedExtrusion]);
            }
            else {
                secondSide.push([pair[0], slotOnConnectedExtrusion]);
            }
        });
    });
    if (firstSide.length !== secondSide.length) {
        return firstSide.length > secondSide.length ? firstSide : secondSide;
    }
    if (fasteners.some((fastener) => { var _a; return types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP.includes((_a = fastener.fastenerType) !== null && _a !== void 0 ? _a : ''); })) {
        return firstSide;
    }
    if (fasteners[0].slotNumber) {
        return [...firstSide, ...secondSide];
    }
    const mainExtrusionEndFaceA = mainExtrusion.position;
    const mainExtrusionEndFaceB = mainExtrusion.position
        .clone()
        .add(tempVector.copy(mainExtrusion.directionNormal).multiplyScalar(mainExtrusion.getLength()));
    const slotOnConnectedExtrusionOnFirstSide = firstSide[0][1];
    const slotOnConnectedExtrusionOnSecondSide = secondSide[0][1];
    if (fasteners.some((fastener) => fastener.fastenerType === types_1.FASTENER_TYPES.INNER_CONNECTOR)) {
        const mainExtrusionBBox = Utils.getAABBox(mainExtrusion);
        const slotOnMainExtrusionOnFirstSide = firstSide[0][0];
        const slotOnMainExtrusionOnSecondSide = secondSide[0][0];
        let firstSlotValid = false;
        let secondSlotValid = false;
        const firstFastener = getFastenerBySlotNumber(fasteners, slotOnConnectedExtrusionOnFirstSide.slotNumber);
        if (firstFastener) {
            visualizeInnerConnectorForOnePairOfSlots(slotOnMainExtrusionOnFirstSide, slotOnConnectedExtrusionOnFirstSide, firstFastener);
            firstSlotValid = checkIfInnerConnectorAlignedByBBoxToMainExtrusion(Utils.getAABBox(firstFastener), mainExtrusionBBox, connectedExtrusion.directionNormal);
        }
        const secondFastener = getFastenerBySlotNumber(fasteners, slotOnConnectedExtrusionOnSecondSide.slotNumber);
        if (secondFastener) {
            visualizeInnerConnectorForOnePairOfSlots(slotOnMainExtrusionOnSecondSide, slotOnConnectedExtrusionOnSecondSide, secondFastener);
            secondSlotValid = checkIfInnerConnectorAlignedByBBoxToMainExtrusion(Utils.getAABBox(secondFastener), mainExtrusionBBox, connectedExtrusion.directionNormal);
        }
        if (firstSlotValid && !secondSlotValid) {
            return firstSide;
        }
        if (!firstSlotValid && secondSlotValid) {
            return secondSide;
        }
    }
    const distanceFromFirstSideToEndFaceA = tempVector
        .subVectors(slotOnConnectedExtrusionOnFirstSide.surfacePoint, mainExtrusionEndFaceA)
        .length();
    const distanceFromSecondSideToEndFaceA = tempVector
        .subVectors(slotOnConnectedExtrusionOnSecondSide.surfacePoint, mainExtrusionEndFaceA)
        .length();
    const minDistanceToEndfaceForFirstSide = Math.min(distanceFromFirstSideToEndFaceA, tempVector2.subVectors(slotOnConnectedExtrusionOnFirstSide.surfacePoint, mainExtrusionEndFaceB).length());
    const minDistanceToEndfaceForSecondSide = Math.min(distanceFromSecondSideToEndFaceA, tempVector2.subVectors(slotOnConnectedExtrusionOnSecondSide.surfacePoint, mainExtrusionEndFaceB).length());
    const excludeCollisionUUIDs = new Set([firstSide[0][0].objectUUID, firstSide[0][1].objectUUID]);
    const [numberOfCollidedFastenersOnFirstSide, numberOfCollidedFastenersOnSecondSide] = [firstSide, secondSide].map((side) => side.filter(([slotOnMainExtrusion, slotOnConnectedExtrusion]) => {
        const fastener = getFastenerBySlotNumber(fasteners, slotOnConnectedExtrusion.slotNumber);
        if (!fastener) {
            return false;
        }
        const visualized = visualizeGroupAFastenerForOnePairOfSlots(slotOnMainExtrusion, slotOnConnectedExtrusion, fastener, connectedExtrusion);
        if (!visualized) {
            return false;
        }
        Viewer_1.default.instance.getScene().add(fastener);
        const collided = Viewer_1.default.instance.collisionProcessor.testCollisions(fastener, Utils.getOBB(fastener), {
            excludeIDs: excludeCollisionUUIDs,
            firstFoundCollisionOnly: true,
        }).result;
        fastener.removeFromParent();
        return collided;
    }).length);
    if (numberOfCollidedFastenersOnFirstSide < numberOfCollidedFastenersOnSecondSide) {
        return firstSide;
    }
    if (numberOfCollidedFastenersOnFirstSide > numberOfCollidedFastenersOnSecondSide) {
        return secondSide;
    }
    if (!Utils.areEqual(minDistanceToEndfaceForFirstSide, minDistanceToEndfaceForSecondSide)) {
        if (minDistanceToEndfaceForFirstSide < minDistanceToEndfaceForSecondSide) {
            return firstSide;
        }
        return secondSide;
    }
    if (distanceFromFirstSideToEndFaceA < distanceFromSecondSideToEndFaceA) {
        return firstSide;
    }
    return secondSide;
}
function validateIfFastenersOfAGroupCanBePlaced(firstExtrusion, secondExtrusion) {
    var _a, _b, _c;
    const [mainExtrusion, connectedExtrusion] = getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion);
    if (!findSnappingToSlots((_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = mainExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped) {
        return [];
    }
    const result = [];
    const mainExtrusionSlotBBox = new three_1.Box3();
    const connectedExtrusionSlotBBox = new three_1.Box3();
    const vectorToExpandConnectedObjectSlotsBBox = Utils.absVector(connectedExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    const vectorToExpandMainObjectSlotBbox = Utils.absVector(mainExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    (_c = mainExtrusion.getSlots()) === null || _c === void 0 ? void 0 : _c.forEach((mainExtrusionSlot) => {
        var _a;
        Utils.getBox3OfSlotSurface(mainExtrusionSlot, mainExtrusionSlotBBox);
        mainExtrusionSlotBBox.expandByVector(vectorToExpandMainObjectSlotBbox);
        const slotsOnConnectedExtrusion = [];
        (_a = connectedExtrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.forEach((connectedExtrusionSlot) => {
            Utils.getBox3OfSlotSurface(connectedExtrusionSlot, connectedExtrusionSlotBBox);
            connectedExtrusionSlotBBox.expandByVector(vectorToExpandConnectedObjectSlotsBBox);
            const slotsIntersects = connectedExtrusionSlotBBox.intersectsBox(mainExtrusionSlotBBox);
            const slotsProjectedOnNormalOriginAreTheSame = Utils.areVectorsEqual(tempVector
                .copy(connectedExtrusionSlot.origin)
                .projectOnPlane(connectedExtrusionSlot.normal)
                .projectOnPlane(mainExtrusionSlot.normal), tempVector2
                .copy(mainExtrusionSlot.origin)
                .projectOnPlane(connectedExtrusionSlot.normal)
                .projectOnPlane(mainExtrusionSlot.normal), consts_1.consts.TWO_FLOAT_EPSILON);
            if (slotsIntersects && slotsProjectedOnNormalOriginAreTheSame) {
                slotsOnConnectedExtrusion.push(connectedExtrusionSlot);
            }
        });
        if (slotsOnConnectedExtrusion.length) {
            result.push([mainExtrusionSlot, slotsOnConnectedExtrusion]);
        }
    });
    return result;
}
exports.validateIfFastenersOfAGroupCanBePlaced = validateIfFastenersOfAGroupCanBePlaced;
function validateIfFastenersOfDoubleAnchorGroupCanBePlaced(firstExtrusion, secondExtrusion) {
    const availableSlotsForAGroup = validateIfFastenersOfAGroupCanBePlaced(firstExtrusion, secondExtrusion);
    const [, connectedExtrusion] = getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion);
    const isEverySlotOnMainExtrusionHas2SlotsOnConnected = availableSlotsForAGroup.every((pair) => pair[1].length === 2);
    if (!availableSlotsForAGroup.length ||
        // in user story is said that connection is valid when every snapping point in a row is snapped
        // this is not checked because if 2 slots on connected extrusion are "snapped" it means that all between them are snapped too
        !isEverySlotOnMainExtrusionHas2SlotsOnConnected ||
        Utils.isThinExtrusion(connectedExtrusion)) {
        return [];
    }
    return availableSlotsForAGroup;
}
exports.validateIfFastenersOfDoubleAnchorGroupCanBePlaced = validateIfFastenersOfDoubleAnchorGroupCanBePlaced;
function validateIfPlateConnectorsCanBePlaced(firstExtrusion, secondExtrusion) {
    const doubleAnchorValidationResult = validateIfFastenersOfDoubleAnchorGroupCanBePlaced(firstExtrusion, secondExtrusion);
    if (!doubleAnchorValidationResult) {
        return [];
    }
    const zeroDegreesValidationResult = validateIfZeroDegreeCentralConnectorsCanBePlace(firstExtrusion, secondExtrusion);
    if (zeroDegreesValidationResult.length !== 2) {
        return [];
    }
    return doubleAnchorValidationResult;
}
exports.validateIfPlateConnectorsCanBePlaced = validateIfPlateConnectorsCanBePlaced;
function validateIfFastenersOfScrewGroupCanBePlaced(firstExtrusion, secondExtrusion) {
    var _a;
    const result = [];
    const [mainExtrusion, connectedExtrusion] = getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion);
    if (isExistProjectedInterferenceForOppositeSide(mainExtrusion, connectedExtrusion) ||
        Utils.isThinExtrusion(connectedExtrusion) ||
        !findSnappingToSlots(connectedExtrusion.getInboundSnappingPointsRaw() || [], mainExtrusion.getSlots() || [], 'onlyCheckIfSnappingExists').snapped) {
        return result;
    }
    const connectedExtrusionSlots = connectedExtrusion.getSlots() || [];
    const snappingPoints = connectedExtrusion.getInboundSnappingPoints() || [];
    (_a = mainExtrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.forEach((mainExtrusionSlot) => {
        const { snappingPointsIndices } = findSnappingToSlots(snappingPoints, [mainExtrusionSlot], 'findBoth');
        if (!snappingPointsIndices.length) {
            return;
        }
        const snappingPointOnConnectedExtrusion = snappingPointsIndices.map((snappingPointIndex) => snappingPoints[snappingPointIndex]);
        result.push([mainExtrusionSlot, connectedExtrusionSlots, snappingPointOnConnectedExtrusion]);
    });
    return result;
}
exports.validateIfFastenersOfScrewGroupCanBePlaced = validateIfFastenersOfScrewGroupCanBePlaced;
function validateIfFastenersForEndGroupCanBePlaced(firstExtrusion, secondExtrusion) {
    var _a, _b, _c;
    const [mainExtrusion, connectedExtrusion] = getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion);
    const result = {
        availableSlots: [],
        isValidDoubleFastener: false,
    };
    if (isExistProjectedInterferenceForOppositeSide(mainExtrusion, connectedExtrusion) ||
        Utils.isThinExtrusion(connectedExtrusion) ||
        !findSnappingToSlots((_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = mainExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped) {
        return result;
    }
    const mainExtrusionSlotBBox = new three_1.Box3();
    const connectedExtrusionSlotBBox = new three_1.Box3();
    const vectorToExpandConnectedObjectSlotsBBox = Utils.absVector(connectedExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    const vectorToExpandMainObjectSlotBbox = Utils.absVector(mainExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    (_c = mainExtrusion.getSlots()) === null || _c === void 0 ? void 0 : _c.forEach((mainExtrusionSlot) => {
        var _a;
        const slotsOnConnectedExtrusion = [];
        Utils.getBox3OfSlotSurface(mainExtrusionSlot, mainExtrusionSlotBBox);
        mainExtrusionSlotBBox.expandByVector(vectorToExpandMainObjectSlotBbox);
        (_a = connectedExtrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.forEach((connectedExtrusionSlot) => {
            Utils.getBox3OfSlotSurface(connectedExtrusionSlot, connectedExtrusionSlotBBox);
            connectedExtrusionSlotBBox.expandByVector(vectorToExpandConnectedObjectSlotsBBox);
            if (connectedExtrusionSlotBBox.intersectsBox(mainExtrusionSlotBBox)) {
                slotsOnConnectedExtrusion.push(connectedExtrusionSlot);
            }
        });
        const snappingPointsOnConnectedExtrusion = Utils.getSnappingPointsOnExtrusionForAdjoinedSlot(connectedExtrusion, mainExtrusionSlot);
        if (slotsOnConnectedExtrusion.length && snappingPointsOnConnectedExtrusion.length) {
            result.availableSlots.push([mainExtrusionSlot, slotsOnConnectedExtrusion, snappingPointsOnConnectedExtrusion]);
        }
    });
    result.isValidDoubleFastener = result.availableSlots.every(([, , snappingPointsOnConnectedExtrusion]) => snappingPointsOnConnectedExtrusion.length % 2 === 0);
    return result;
}
exports.validateIfFastenersForEndGroupCanBePlaced = validateIfFastenersForEndGroupCanBePlaced;
function validateIfEndToEndFastenersCanBePlaced(firstExtrusion, secondExtrusion) {
    var _a;
    const [mainExtrusion, connectedExtrusion] = getMainAndConnectedExtrusionForEndToEndSnapping(firstExtrusion, secondExtrusion);
    const result = [];
    const mainExtrusionSlotBBox = new three_1.Box3();
    const connectedExtrusionSlotBBox = new three_1.Box3();
    const vectorToExpandMainObjectSlotBbox = Utils.absVector(mainExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    const vectorToExpandConnectedObjectSlotsBBox = Utils.absVector(connectedExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    (_a = mainExtrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.forEach((mainExtrusionSlot) => {
        var _a;
        Utils.getBox3OfSlotSurface(mainExtrusionSlot, mainExtrusionSlotBBox);
        mainExtrusionSlotBBox.expandByVector(vectorToExpandMainObjectSlotBbox);
        mainExtrusionSlotBBox.expandByVector(Utils.absVector(mainExtrusionSlot.normal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE));
        for (const connectedExtrusionSlot of (_a = connectedExtrusion.getSlots()) !== null && _a !== void 0 ? _a : []) {
            Utils.getBox3OfSlotSurface(connectedExtrusionSlot, connectedExtrusionSlotBBox);
            connectedExtrusionSlotBBox.expandByVector(vectorToExpandConnectedObjectSlotsBBox);
            connectedExtrusionSlotBBox.expandByVector(Utils.absVector(connectedExtrusionSlot.normal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE));
            if (connectedExtrusionSlotBBox.intersectsBox(mainExtrusionSlotBBox)) {
                result.push([mainExtrusionSlot, connectedExtrusionSlot]);
                break;
            }
        }
    });
    return result;
}
exports.validateIfEndToEndFastenersCanBePlaced = validateIfEndToEndFastenersCanBePlaced;
function validateIfSocketHeadCapScrewsCanBePlaced(firstExtrusion, secondExtrusion) {
    var _a, _b, _c;
    const [mainExtrusion, connectedExtrusion] = getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion);
    // TODO: following check was disabled due to inability to place socket head cap screws in valid cases
    // it need to be investigated and refactored. For now it disabled to just unlock possibility to place desired fasteners
    if (
    // isExistProjectedInterferenceForOppositeSide(mainExtrusion, connectedExtrusion) ||
    Utils.isThinExtrusion(connectedExtrusion) ||
        !findSnappingToSlots((_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = mainExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped) {
        return [];
    }
    const result = [];
    (_c = mainExtrusion.getSlots()) === null || _c === void 0 ? void 0 : _c.forEach((mainExtrusionSlot) => {
        const snappingPointsOnConnectedExtrusion = Utils.getSnappingPointsOnExtrusionForAdjoinedSlot(connectedExtrusion, mainExtrusionSlot);
        const oppositeSlot = Utils.getOppositeSlot(mainExtrusion, mainExtrusionSlot);
        if (oppositeSlot && snappingPointsOnConnectedExtrusion.length) {
            result.push([oppositeSlot, snappingPointsOnConnectedExtrusion]);
        }
    });
    return result;
}
exports.validateIfSocketHeadCapScrewsCanBePlaced = validateIfSocketHeadCapScrewsCanBePlaced;
function validateIfZeroDegreeCentralConnectorsCanBePlace(firstExtrusion, secondExtrusion) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const [mainExtrusion, connectedExtrusion] = getMainAndConnectedExtrusionForPerpendicularSnapping(firstExtrusion, secondExtrusion);
    if (Utils.isThinExtrusion(connectedExtrusion) ||
        !findSnappingToSlots((_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = mainExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped) {
        return [];
    }
    const result = [];
    const allSnappingPointsOnEndFaceA = (_d = (_c = connectedExtrusion
        .getInboundSnappingPointsRaw()) === null || _c === void 0 ? void 0 : _c.filter((point) => Utils.areEqual(point.dot(connectedExtrusion.directionNormal), connectedExtrusion.position.dot(connectedExtrusion.directionNormal)))) !== null && _d !== void 0 ? _d : [];
    const snappedSnappingPoins = findSnappingToSlots((_e = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _e !== void 0 ? _e : [], (_f = mainExtrusion.getSlots()) !== null && _f !== void 0 ? _f : [], 'findBoth').snappingPoints;
    const axisForConnectedExtrusionSlots = firstExtrusion.directionNormal.clone().cross(secondExtrusion.directionNormal);
    const connectedExtrusionSlotsOnFirstSide = (_h = (_g = connectedExtrusion
        .getSlots()) === null || _g === void 0 ? void 0 : _g.filter((slot) => Utils.areVectorsEqual(slot.normal, axisForConnectedExtrusionSlots))) !== null && _h !== void 0 ? _h : [];
    const connectedExtrusionSlotsOnSecondSide = (_k = (_j = connectedExtrusion
        .getSlots()) === null || _j === void 0 ? void 0 : _j.filter((slot) => Utils.areVectorsEqual(slot.normal, tempVector.copy(axisForConnectedExtrusionSlots).negate()))) !== null && _k !== void 0 ? _k : [];
    const getValidSlotsOnSide = (slots) => slots.reduce((validSlots, slot) => {
        const nearestSnappedSnappingPoint = Utils.getNearestSnappingPointToSlot(slot, snappedSnappingPoins);
        const nearestEndFaceSnappingPoint = Utils.getNearestSnappingPointToSlot(slot, allSnappingPointsOnEndFaceA);
        const hasMatchingSnappingPoints = nearestSnappedSnappingPoint !== undefined &&
            nearestEndFaceSnappingPoint !== undefined &&
            Utils.areVectorsEqual(tempVector.copy(nearestEndFaceSnappingPoint).projectOnPlane(connectedExtrusion.directionNormal), tempVector2.copy(nearestSnappedSnappingPoint).projectOnPlane(connectedExtrusion.directionNormal));
        if (!hasMatchingSnappingPoints) {
            return validSlots;
        }
        validSlots.push({ slot, nearestSnappedSnappingPoint });
        return validSlots;
    }, []);
    const validSlotsOnFirstSide = getValidSlotsOnSide(connectedExtrusionSlotsOnFirstSide);
    const validSlotsOnSecondSide = getValidSlotsOnSide(connectedExtrusionSlotsOnSecondSide);
    [validSlotsOnFirstSide, validSlotsOnSecondSide].forEach((validSlotsOnSide) => {
        var _a;
        if (validSlotsOnSide.length) {
            const slotOnMainExtrusion = findSnappingToSlots([validSlotsOnSide[0].nearestSnappedSnappingPoint], (_a = mainExtrusion.getSlots()) !== null && _a !== void 0 ? _a : [], 'findSlots').slots[0];
            if (slotOnMainExtrusion) {
                result.push({
                    slotOnMainExtrusion,
                    slotsOnConnectedExtrusion: validSlotsOnSide,
                });
            }
        }
    });
    return result;
}
exports.validateIfZeroDegreeCentralConnectorsCanBePlace = validateIfZeroDegreeCentralConnectorsCanBePlace;
function validateIfScrewCombinationFastenerCanBePlace(firstExtrusion, secondExtrusion) {
    var _a, _b;
    let mainExtrusion = firstExtrusion;
    let angledExtrusion = secondExtrusion;
    if (Utils.areNotEqual(mainExtrusion.scalingAngle, 0)) {
        [mainExtrusion, angledExtrusion] = [angledExtrusion, mainExtrusion];
    }
    if (!findSnappingToSlots((_a = angledExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = mainExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'onlyCheckIfSnappingExists').snapped) {
        return [];
    }
    const mainExtrusionSlots = mainExtrusion.getSlots() || [];
    const connectedExtrusionSlots = angledExtrusion.getSlots() || [];
    const longestSlotNumbers = Utils.getLongestSlotNumbersForAngledExtrusion(angledExtrusion, mainExtrusion);
    const longestSlotsOnConnectedExtrusion = connectedExtrusionSlots.filter((slot) => longestSlotNumbers.includes(slot.slotNumber));
    const result = [];
    const mainExtrusionSlotBBox = new three_1.Box3();
    const connectedExtrusionSlotBBox = new three_1.Box3();
    const vectorToExpandConnectedObjectSlotsBBox = Utils.absVector(angledExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    const vectorToExpandMainObjectSlotBbox = Utils.absVector(mainExtrusion.directionNormal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    mainExtrusionSlots.forEach((mainExtrusionSlot) => {
        var _a;
        Utils.getBox3OfSlotSurface(mainExtrusionSlot, mainExtrusionSlotBBox);
        mainExtrusionSlotBBox.expandByVector(vectorToExpandMainObjectSlotBbox);
        const snappedSnappingPoints = findSnappingToSlots((_a = angledExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], [mainExtrusionSlot], 'findBoth').snappingPoints;
        longestSlotsOnConnectedExtrusion.forEach((connectedExtrusionSlot) => {
            Utils.getBox3OfSlotSurface(connectedExtrusionSlot, connectedExtrusionSlotBBox);
            connectedExtrusionSlotBBox.expandByVector(vectorToExpandConnectedObjectSlotsBBox);
            const slotsIntersects = connectedExtrusionSlotBBox.intersectsBox(mainExtrusionSlotBBox);
            if (!slotsIntersects) {
                return;
            }
            const nearestSnappingPoint = Utils.getNearestSnappingPointToSlot(connectedExtrusionSlot, snappedSnappingPoints);
            if (!nearestSnappingPoint) {
                return;
            }
            result.push([mainExtrusionSlot, connectedExtrusionSlot, nearestSnappingPoint]);
        });
    });
    return result;
}
exports.validateIfScrewCombinationFastenerCanBePlace = validateIfScrewCombinationFastenerCanBePlace;
function rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener) {
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    fastener.setRotation(Utils.identityQuaternion);
    fastener.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(fastener.directionNormal, connectedExtrusionSlot.normal));
    const axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot = mainExtrusionSlot.origin
        .clone()
        .sub(connectedExtrusionSlot.origin)
        .projectOnVector(connectedExtrusionSlot.direction)
        .normalize();
    if (Utils.areVectorsEqual(axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot, tempVector.copy(fastener.getAlignmentAxis()).negate(), consts_1.consts.FOUR_FLOAT_EPSILON)) {
        fastener.applyQuaternion(tempQuaternion.setFromAxisAngle(connectedExtrusionSlot.normal, Math.PI));
    }
    else if (Utils.areVectorsNotEqual(axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot, fastener.getAlignmentAxis(), consts_1.consts.FOUR_FLOAT_EPSILON)) {
        let angleToRotate = fastener
            .getAlignmentAxis()
            .angleTo(axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot);
        const rotationAxis = axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot
            .clone()
            .cross(fastener.getAlignmentAxis())
            .normalize();
        tempVector.copy(fastener.getAlignmentAxis()).applyAxisAngle(rotationAxis, angleToRotate);
        if (Utils.areVectorsNotEqual(tempVector, axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot, consts_1.consts.FOUR_FLOAT_EPSILON)) {
            angleToRotate = -angleToRotate;
        }
        fastener.applyQuaternion(tempQuaternion.setFromAxisAngle(rotationAxis, angleToRotate));
    }
}
exports.rotateFastenerForGroupAVisualization = rotateFastenerForGroupAVisualization;
function rotateFastenerForEndGroupVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener) {
    fastener.slotNumber = mainExtrusionSlot.slotNumber;
    fastener.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(tempVector.copy(fastener.directionNormal).negate(), mainExtrusionSlot.normal));
    if (!fastener.getAlignmentAxis()) {
        return;
    }
    if (!Utils.areVectorsCollinear(fastener.getAlignmentAxis(), connectedExtrusionSlot.normal)) {
        fastener.applyQuaternion(tempQuaternion.setFromAxisAngle(connectedExtrusionSlot.direction, Math.PI / 2));
    }
}
exports.rotateFastenerForEndGroupVisualization = rotateFastenerForEndGroupVisualization;
function visualizePlateConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener, mainExtrusion, connectedExtrusion) {
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    const fastenerInitialBbox = Utils.getAABBox(fastener);
    const bboxCenter = fastenerInitialBbox.getCenter(new three_1.Vector3());
    const bboxSize = fastenerInitialBbox.getSize(new three_1.Vector3());
    fastener.translate(tempVector.subVectors(mainExtrusionSlot.surfacePoint, bboxCenter));
    fastener.translate(tempVector.copy(mainExtrusionSlot.normal).multiply(bboxSize).divideScalar(2));
    const connectedExtrusionBbox = Utils.getAABBox(connectedExtrusion);
    const fastenerBbox = Utils.getAABBox(fastener);
    const maxPointOfExtrusionBbox = connectedExtrusionBbox.max.dot(mainExtrusionSlot.normal) > connectedExtrusionBbox.min.dot(mainExtrusionSlot.normal)
        ? connectedExtrusionBbox.max
        : connectedExtrusionBbox.min;
    const maxPointOfFastenerBbox = fastenerBbox.max.dot(mainExtrusionSlot.normal) > fastenerBbox.min.dot(mainExtrusionSlot.normal)
        ? fastenerBbox.max
        : fastenerBbox.min;
    fastener.translate(tempVector
        .subVectors(maxPointOfExtrusionBbox, maxPointOfFastenerBbox)
        .projectOnVector(connectedExtrusionSlot.normal));
}
exports.visualizePlateConnectorForOnePairOfSlots = visualizePlateConnectorForOnePairOfSlots;
function visualizeInnerConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener) {
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    fastener.translate(tempVector.subVectors(connectedExtrusionSlot.origin, Utils.getAABBoxCenter(fastener)));
    const cornerWhichHasToBeBetweenSlots = Utils.getPointOnMinCoord(Utils.getBox3Corners(Utils.getAABBox(fastener)), mainExtrusionSlot.normal, connectedExtrusionSlot.normal);
    fastener.translate(tempVector
        .subVectors(connectedExtrusionSlot.origin, cornerWhichHasToBeBetweenSlots)
        .projectOnVector(connectedExtrusionSlot.normal));
    fastener.translate(tempVector
        .subVectors(mainExtrusionSlot.origin, cornerWhichHasToBeBetweenSlots)
        .projectOnVector(mainExtrusionSlot.normal));
}
exports.visualizeInnerConnectorForOnePairOfSlots = visualizeInnerConnectorForOnePairOfSlots;
function visualizeMillingAndTMaticConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener) {
    var _a, _b, _c;
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    const masterSnappingPoint = (_a = fastener.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0];
    if (!masterSnappingPoint) {
        return;
    }
    fastener.translate(tempVector.subVectors(connectedExtrusionSlot.origin, masterSnappingPoint)); // getMasterSnappingPoint
    fastener.translate(tempVector
        .subVectors(mainExtrusionSlot.surfacePoint, (_c = (_b = fastener.getMasterSnappingPoints()) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : fastener.position)
        .projectOnVector(connectedExtrusionSlot.direction));
}
exports.visualizeMillingAndTMaticConnectorForOnePairOfSlots = visualizeMillingAndTMaticConnectorForOnePairOfSlots;
/**
 *
 * @returns true if fastener was visualized
 */
function visualizeGroupAFastenerForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener, connectedExtrusion) {
    var _a;
    // eslint-disable-next-line default-case
    switch (fastener.fastenerType) {
        case types_1.FASTENER_TYPES.NINETY_DEGREE_CENTRAL_CONNECTOR:
            const nearestToSlotSnappingPointOfConnectedExtrusion = Utils.getNearestSnappingPointToSlot(connectedExtrusionSlot, (_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [connectedExtrusion.position]);
            if (!nearestToSlotSnappingPointOfConnectedExtrusion) {
                return false;
            }
            visualizeCentralConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener, nearestToSlotSnappingPointOfConnectedExtrusion);
            return true;
        case types_1.FASTENER_TYPES.ANCHOR_FASTENER:
            visualizeAnchorFastenerForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener);
            return true;
        case types_1.FASTENER_TYPES.MILLING_CONNECTOR:
        case types_1.FASTENER_TYPES.T_MATIC_CONNECTOR:
            visualizeMillingAndTMaticConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener);
            return true;
        case types_1.FASTENER_TYPES.INNER_CONNECTOR:
            visualizeInnerConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener);
            return true;
    }
    return false;
}
exports.visualizeGroupAFastenerForOnePairOfSlots = visualizeGroupAFastenerForOnePairOfSlots;
function visualizeAnchorFastenerForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener) {
    var _a, _b, _c, _d, _e;
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    fastener.translate(tempVector.subVectors(connectedExtrusionSlot.surfacePoint, (_b = (_a = fastener.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : fastener.position)); // getMasterSnappingPoint
    const axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot = mainExtrusionSlot.origin
        .clone()
        .sub(connectedExtrusionSlot.origin)
        .projectOnVector(connectedExtrusionSlot.direction)
        .normalize();
    fastener.translate(tempVector
        .subVectors(mainExtrusionSlot.surfacePoint, (_d = (_c = fastener.getMasterSnappingPoints()) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : fastener.position)
        .projectOnVector(connectedExtrusionSlot.direction));
    fastener.translate(tempVector
        .copy(axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot)
        .setLength(-((_e = fastener.distanceToTheEdge) !== null && _e !== void 0 ? _e : 0)));
    fastener.translate(tempVector.copy(connectedExtrusionSlot.normal).setLength(consts_1.consts.THREE_FLOAT_EPSILON));
}
exports.visualizeAnchorFastenerForOnePairOfSlots = visualizeAnchorFastenerForOnePairOfSlots;
function visualizeCentralConnectorForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener, nearestToSlotSnappingPointOfConnectedExtrusion) {
    var _a, _b, _c;
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    const secondSnappingPoint = fastener.getSecondSnappingPoint();
    if (secondSnappingPoint) {
        fastener.translate(tempVector.subVectors(connectedExtrusionSlot.surfacePoint, secondSnappingPoint));
    } // getMasterSnappingPoint
    const axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot = mainExtrusionSlot.origin
        .clone()
        .sub(connectedExtrusionSlot.origin)
        .projectOnVector(connectedExtrusionSlot.direction)
        .normalize();
    const isZeroDegree = fastener.fastenerType === types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR;
    fastener.translate(tempVector
        .subVectors(mainExtrusionSlot.surfacePoint, (_a = (isZeroDegree ? fastener.getMasterSnappingPoint() : fastener.getSecondSnappingPoint())) !== null && _a !== void 0 ? _a : fastener.position)
        .projectOnVector(connectedExtrusionSlot.direction));
    fastener.translate(tempVector
        .copy(axisFromConnectedExtrusionToMainExtrusionAlongConnectedExtrusionSlot)
        .setLength(-((_b = fastener.distanceToTheEdge) !== null && _b !== void 0 ? _b : 0)));
    fastener.translate(tempVector
        .subVectors(nearestToSlotSnappingPointOfConnectedExtrusion, (_c = (isZeroDegree ? fastener.getSecondSnappingPoint() : fastener.getMasterSnappingPoint())) !== null && _c !== void 0 ? _c : fastener.position)
        .projectOnVector(connectedExtrusionSlot.normal));
}
exports.visualizeCentralConnectorForOnePairOfSlots = visualizeCentralConnectorForOnePairOfSlots;
function visualizeEndFastenerGroupForOneConnection(mainExtrusionSlot, connectedExtrusionSlot, snappingPoint, fastener) {
    var _a, _b, _c, _d;
    fastener.slotNumber = mainExtrusionSlot.slotNumber;
    rotateFastenerForEndGroupVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    fastener.translate(tempVector.subVectors(snappingPoint.origin, (_b = (_a = fastener.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : fastener.position));
    fastener.translate(tempVector
        .subVectors(mainExtrusionSlot.surfacePoint, (_d = (_c = fastener.getMasterSnappingPoints()) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : fastener.position)
        .projectOnVector(connectedExtrusionSlot.direction));
    fastener.translateZ(-mainExtrusionSlot.thickness);
}
exports.visualizeEndFastenerGroupForOneConnection = visualizeEndFastenerGroupForOneConnection;
function visualizeSocketHeadCapScrewForOneConnection(mainExtrusionSlot, snappingPoint, fastener) {
    var _a, _b, _c, _d;
    fastener.slotNumber = mainExtrusionSlot.slotNumber;
    fastener.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(fastener.directionNormal, mainExtrusionSlot.normal));
    fastener.translate(tempVector.subVectors(snappingPoint.origin, (_b = (_a = fastener.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : fastener.position));
    fastener.translate(tempVector
        .subVectors(mainExtrusionSlot.origin, (_d = (_c = fastener.getMasterSnappingPoints()) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : fastener.position)
        .projectOnVector(snappingPoint.normal));
}
exports.visualizeSocketHeadCapScrewForOneConnection = visualizeSocketHeadCapScrewForOneConnection;
function visualizeDoubleEndFastenerForOneConnection(mainExtrusionSlot, snappingPoint, fastener) {
    fastener.slotNumber = mainExtrusionSlot.slotNumber;
    let angleToRotate = fastener.getAlignmentAxis().angleTo(mainExtrusionSlot.direction);
    fastener.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(tempVector.copy(fastener.directionNormal).negate(), mainExtrusionSlot.normal));
    if (Utils.areVectorsEqual(fastener.getAlignmentAxis(), mainExtrusionSlot.direction)) {
        fastener.applyQuaternion(tempQuaternion.setFromAxisAngle(mainExtrusionSlot.normal, Math.PI));
    }
    if (!Utils.areVectorsCollinear(fastener.getAlignmentAxis(), mainExtrusionSlot.direction)) {
        tempVector.copy(fastener.getAlignmentAxis()).applyAxisAngle(mainExtrusionSlot.normal, angleToRotate);
        if (Utils.areVectorsEqual(tempVector, mainExtrusionSlot.direction)) {
            angleToRotate = -angleToRotate;
        }
        fastener.applyQuaternion(tempQuaternion.setFromAxisAngle(mainExtrusionSlot.normal, angleToRotate));
    }
    fastener.translate(tempVector.subVectors(snappingPoint.origin, Utils.getMasterSnappingPoints(fastener)[0]));
    fastener.translateZ(-mainExtrusionSlot.thickness);
}
exports.visualizeDoubleEndFastenerForOneConnection = visualizeDoubleEndFastenerForOneConnection;
function visualizeScrewCombinationFastenerForOnePairOfSlots(mainExtrusionSlot, snappingPoint, fastener) {
    var _a, _b;
    fastener.slotNumber = mainExtrusionSlot.slotNumber;
    fastener.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(fastener.directionNormal, mainExtrusionSlot.normal));
    if (!Utils.areVectorsCollinear(fastener.getAlignmentAxis(), mainExtrusionSlot.direction, consts_1.consts.THREE_FLOAT_EPSILON)) {
        fastener.applyQuaternion(tempQuaternion.setFromAxisAngle(mainExtrusionSlot.normal, Math.PI / 2));
    }
    fastener.translate(tempVector.subVectors(snappingPoint, (_b = (_a = fastener.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : fastener.position));
    fastener.translateZ(-fastener.partDetails.holeDepth);
}
exports.visualizeScrewCombinationFastenerForOnePairOfSlots = visualizeScrewCombinationFastenerForOnePairOfSlots;
function visualizeFastenerForAandDoubleAnchorGroupsAndPlateConnectors(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes) {
    var _a, _b;
    let mainExtrusion = firstExtrusion;
    let connectedExtrusion = secondExtrusion;
    if (((_b = (_a = availableSlots[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.objectUUID) === connectedExtrusion.uuid) {
        const temp = mainExtrusion;
        mainExtrusion = connectedExtrusion;
        connectedExtrusion = temp;
    }
    let fasteners = [];
    const slotsOnConnectedExtrusionForGroupA = [];
    const useTwoFastenersPerOneSlotOnMainExtrusion = (!fastenerPrototypes.some((fastenerPrototype) => { var _a; return types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP.includes((_a = fastenerPrototype.fastenerType) !== null && _a !== void 0 ? _a : ''); }) ||
        fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.PLATE_CONNECTOR)) &&
        availableSlots.some(([slotOnMainExtrusion]) => {
            var _a;
            return (findSnappingToSlots((_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], [slotOnMainExtrusion], 'findBoth')
                .snappingPoints.length > 1);
        });
    const pairsOfSlots = useTwoFastenersPerOneSlotOnMainExtrusion
        ? availableSlots.flatMap((pair) => pair[1].map((slotOnConnectedExtrusion) => [pair[0], slotOnConnectedExtrusion]))
        : selectSideSlotsForGroupA(availableSlots, mainExtrusion, connectedExtrusion, fastenerPrototypes);
    const pairsOfSlotsWithFasteners = pairsOfSlots.map((pair) => {
        const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, pair[1].slotNumber);
        if (!fastenerPrototype) {
            return null;
        }
        return [...pair, fastenerPrototype.clone()];
    });
    const visualizedPairs = pairsOfSlotsWithFasteners.flatMap((pair) => {
        var _a;
        if (!pair) {
            return [];
        }
        const fastener = pair[2];
        switch (fastener.fastenerType) {
            case types_1.FASTENER_TYPES.NINETY_DEGREE_CENTRAL_CONNECTOR: {
                const nearestSnappingPoint = Utils.getNearestSnappingPointToSlot(pair[1], (_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [connectedExtrusion.position]);
                if (!nearestSnappingPoint) {
                    return [];
                }
                visualizeCentralConnectorForOnePairOfSlots(...pair, nearestSnappingPoint);
                return [pair];
            }
            case types_1.FASTENER_TYPES.ANCHOR_FASTENER:
            case types_1.FASTENER_TYPES.DOUBLE_ANCHOR_FASTENER:
            case types_1.FASTENER_TYPES.BOLT_CONNECTOR:
                visualizeAnchorFastenerForOnePairOfSlots(...pair);
                return [pair];
            case types_1.FASTENER_TYPES.MILLING_CONNECTOR:
            case types_1.FASTENER_TYPES.T_MATIC_CONNECTOR:
                visualizeMillingAndTMaticConnectorForOnePairOfSlots(...pair);
                return [pair];
            case types_1.FASTENER_TYPES.INNER_CONNECTOR:
                visualizeInnerConnectorForOnePairOfSlots(...pair);
                return [pair];
            case types_1.FASTENER_TYPES.PLATE_CONNECTOR:
                visualizePlateConnectorForOnePairOfSlots(pair[0], pair[1], fastener, mainExtrusion, connectedExtrusion);
                return [pair];
            default:
                fasteners = null;
                return [];
        }
    });
    fasteners = fasteners === null || fasteners === void 0 ? void 0 : fasteners.concat(visualizedPairs.map((pair) => pair[2]));
    slotsOnConnectedExtrusionForGroupA.push(...visualizedPairs.map((pair) => pair[1]));
    if (fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.DOUBLE_ANCHOR_FASTENER)) {
        slotsOnConnectedExtrusionForGroupA.push(...slotsOnConnectedExtrusionForGroupA
            .map((slot) => Utils.getOppositeSlot(connectedExtrusion, slot))
            .filter((slot) => !!slot));
    }
    return (fasteners && {
        fasteners,
        slotsOnConnectedExtrusionForGroupA,
    });
}
exports.visualizeFastenerForAandDoubleAnchorGroupsAndPlateConnectors = visualizeFastenerForAandDoubleAnchorGroupsAndPlateConnectors;
function visualizeDoubleEndFasteners(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes) {
    var _a, _b;
    let mainExtrusion = firstExtrusion;
    const connectedExtrusion = secondExtrusion;
    if (((_b = (_a = availableSlots[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.objectUUID) === connectedExtrusion.uuid) {
        mainExtrusion = connectedExtrusion;
    }
    const fasteners = [];
    const slotNumbersOnMainExtrusionWithDistanceToSnappingPoint = [];
    const mainExtrusionEndFaceA = mainExtrusion.position;
    availableSlots.forEach(([slotOnMainExtrusion, slotsOnConnectedExtrusion, snappingPointsOnConnectedExtrusion]) => {
        const mainSlotDirectionAxisIndex = Utils.getWorldAxisIndex(mainExtrusion.directionNormal);
        const sortDirection = mainExtrusion.directionNormal.toArray()[mainSlotDirectionAxisIndex] < 0 ? 1 : -1;
        snappingPointsOnConnectedExtrusion.sort((firstPoint, secondPoint) => sortDirection *
            (firstPoint.origin.toArray()[mainSlotDirectionAxisIndex] -
                secondPoint.origin.toArray()[mainSlotDirectionAxisIndex]));
        snappingPointsOnConnectedExtrusion.forEach((snappingPoint, snappingPointIndex) => {
            if (snappingPointIndex % 2 !== 0) {
                return;
            }
            const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotOnMainExtrusion.slotNumber);
            if (!fastenerPrototype) {
                return;
            }
            const fastener = fastenerPrototype.clone();
            const nextSnappingPoint = snappingPointsOnConnectedExtrusion[snappingPointIndex + 1];
            visualizeDoubleEndFastenerForOneConnection(slotOnMainExtrusion, snappingPoint, fastener);
            fasteners.push(fastener);
            const distanceFromEndFaceAToCurrentSnappingPoint = mainExtrusion.directionNormal.dot(tempVector.subVectors(snappingPoint.origin, mainExtrusionEndFaceA));
            const distanceFromEndFaceAToNextSnappingPoint = mainExtrusion.directionNormal.dot(tempVector.subVectors(nextSnappingPoint.origin, mainExtrusionEndFaceA));
            slotNumbersOnMainExtrusionWithDistanceToSnappingPoint.push({
                slotNumber: slotOnMainExtrusion.slotNumber,
                distance: distanceFromEndFaceAToCurrentSnappingPoint,
            }, {
                slotNumber: slotOnMainExtrusion.slotNumber,
                distance: distanceFromEndFaceAToNextSnappingPoint,
            });
            fastener.distanceToTheEdge = distanceFromEndFaceAToCurrentSnappingPoint;
        });
    });
    return {
        fasteners,
        slotNumbersOnMainExtrusionWithDistanceToSnappingPoint,
    };
}
exports.visualizeDoubleEndFasteners = visualizeDoubleEndFasteners;
function visualizeFastenerForEndGroup(firstExtrusion, secondExtrusion, availableSlots, isValidDoubleFastener, fastenerPrototypes) {
    var _a, _b;
    if (fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.DOUBLE_END_FASTENERS)) {
        return isValidDoubleFastener
            ? visualizeDoubleEndFasteners(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes)
            : null;
    }
    let mainExtrusion = firstExtrusion;
    const connectedExtrusion = secondExtrusion;
    if (((_b = (_a = availableSlots[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.objectUUID) === connectedExtrusion.uuid) {
        mainExtrusion = connectedExtrusion;
    }
    const fasteners = [];
    const slotNumbersOnMainExtrusionWithDistanceToSnappingPoint = [];
    const mainExtrusionEndFaceA = mainExtrusion.position;
    availableSlots.forEach(([slotOnMainExtrusion, slotsOnConnectedExtrusion, snappingPointsOnConnectedExtrusion]) => {
        snappingPointsOnConnectedExtrusion.forEach((snappingPoint) => {
            const distanceFromEndFaceAToSnappingPoint = mainExtrusion.directionNormal.dot(tempVector.subVectors(snappingPoint.origin, mainExtrusionEndFaceA));
            const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotOnMainExtrusion.slotNumber, distanceFromEndFaceAToSnappingPoint);
            if (!fastenerPrototype) {
                return;
            }
            const fastener = fastenerPrototype.clone();
            visualizeEndFastenerGroupForOneConnection(slotOnMainExtrusion, slotsOnConnectedExtrusion[0], snappingPoint, fastener);
            slotNumbersOnMainExtrusionWithDistanceToSnappingPoint.push({
                slotNumber: slotOnMainExtrusion.slotNumber,
                distance: distanceFromEndFaceAToSnappingPoint,
            });
            fastener.distanceToTheEdge = distanceFromEndFaceAToSnappingPoint;
            fasteners.push(fastener);
        });
    });
    return {
        fasteners,
        slotNumbersOnMainExtrusionWithDistanceToSnappingPoint,
    };
}
exports.visualizeFastenerForEndGroup = visualizeFastenerForEndGroup;
function visualizeEndToEndFastenerForOnePairOfSlots(mainExtrusionSlot, connectedExtrusionSlot, fastener) {
    rotateFastenerForGroupAVisualization(mainExtrusionSlot, connectedExtrusionSlot, fastener);
    fastener.slotNumber = connectedExtrusionSlot.slotNumber;
    const fastenerSnappingPoints = fastener.getInboundSnappingPointsRaw();
    if (!fastenerSnappingPoints || (fastenerSnappingPoints === null || fastenerSnappingPoints === void 0 ? void 0 : fastenerSnappingPoints.length) < 2) {
        return null;
    }
    const [firstSnappingPoint, secondSnappingPoint] = fastenerSnappingPoints;
    const centerOfFastener = firstSnappingPoint.add(secondSnappingPoint).divideScalar(2);
    const similarPointsForSlots = mainExtrusionSlot.points.filter((element1) => connectedExtrusionSlot.points.some((element2) => Utils.areVectorsEqual(element1, element2, consts_1.consts.TWO_FLOAT_EPSILON)));
    const centerOfMainSlot = similarPointsForSlots[0].clone().add(similarPointsForSlots[1]).divideScalar(2);
    fastener.translate(tempVector2.subVectors(centerOfMainSlot, centerOfFastener));
    if (fastener.fastenerType === types_1.FASTENER_TYPES.BUTT_FASTENER) {
        const offset = tempVector2.subVectors(mainExtrusionSlot.surfacePoint, centerOfMainSlot).dot(mainExtrusionSlot.normal) +
            consts_1.consts.TWO_FLOAT_EPSILON;
        fastener.translate(tempVector2.copy(mainExtrusionSlot.normal).multiplyScalar(offset));
    }
    return {
        fasteners: [fastener],
        slotNumbersOnMainExtrusionForEndToEnd: [mainExtrusionSlot.slotNumber],
        slotNumbersOnConnectedExtrusionForEndToEnd: [connectedExtrusionSlot.slotNumber],
    };
}
exports.visualizeEndToEndFastenerForOnePairOfSlots = visualizeEndToEndFastenerForOnePairOfSlots;
function visualizeEndToEndFasteners(availableSlots, fastenerPrototypes) {
    const fasteners = [];
    const slotNumbersOnMainExtrusionForEndToEnd = [];
    const slotNumbersOnConnectedExtrusionForEndToEnd = [];
    availableSlots.forEach(([slotOnMainExtrusion, slotOnConnectedExtrusion]) => {
        const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotOnConnectedExtrusion.slotNumber);
        if (!fastenerPrototype) {
            return;
        }
        const fastener = fastenerPrototype.clone();
        visualizeEndToEndFastenerForOnePairOfSlots(slotOnMainExtrusion, slotOnConnectedExtrusion, fastener);
        fasteners.push(fastener);
        slotNumbersOnMainExtrusionForEndToEnd.push(slotOnMainExtrusion.slotNumber);
        slotNumbersOnConnectedExtrusionForEndToEnd.push(slotOnConnectedExtrusion.slotNumber);
    });
    return {
        fasteners,
        slotNumbersOnMainExtrusionForEndToEnd,
        slotNumbersOnConnectedExtrusionForEndToEnd,
    };
}
exports.visualizeEndToEndFasteners = visualizeEndToEndFasteners;
function visualizeSocketHeadCapScrews(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes) {
    var _a, _b;
    const mainExtrusion = ((_b = (_a = availableSlots[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.objectUUID) === secondExtrusion.uuid ? secondExtrusion : firstExtrusion;
    const fasteners = [];
    const slotNumbersOnMainExtrusionWithDistanceToSnappingPoint = [];
    const mainExtrusionEndFaceA = mainExtrusion.position;
    availableSlots.forEach(([slotOnMainExtrusion, snappingPointsOnConnectedExtrusion]) => {
        snappingPointsOnConnectedExtrusion.forEach((snappingPoint) => {
            const distanceFromEndFaceAToSnappingPoint = mainExtrusion.directionNormal.dot(tempVector.subVectors(snappingPoint.origin, mainExtrusionEndFaceA));
            const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotOnMainExtrusion.slotNumber, distanceFromEndFaceAToSnappingPoint);
            if (!fastenerPrototype) {
                return;
            }
            const fastener = fastenerPrototype.clone();
            visualizeSocketHeadCapScrewForOneConnection(slotOnMainExtrusion, snappingPoint, fastener);
            fastener.distanceToTheEdge = distanceFromEndFaceAToSnappingPoint;
            fasteners.push(fastener);
            slotNumbersOnMainExtrusionWithDistanceToSnappingPoint.push({
                slotNumber: slotOnMainExtrusion.slotNumber,
                distance: distanceFromEndFaceAToSnappingPoint,
            });
        });
    });
    return {
        fasteners,
        slotNumbersOnMainExtrusionWithDistanceToSnappingPoint,
    };
}
exports.visualizeSocketHeadCapScrews = visualizeSocketHeadCapScrews;
function visualizeZeroDegreesConnector(firstExtrusion, secondExtrusion, availableSides, fastenerPrototypes) {
    let mainExtrusion = firstExtrusion;
    const connectedExtrusion = secondExtrusion;
    if (availableSides[0].slotOnMainExtrusion.objectUUID === connectedExtrusion.uuid) {
        mainExtrusion = connectedExtrusion;
    }
    const fasteners = [];
    const slotsOnConnectedExtrusionForGroupA = [];
    const useSlotsOnBothSides = availableSides.length > 1 &&
        availableSides[0].slotOnMainExtrusion.slotNumber !== availableSides[1].slotOnMainExtrusion.slotNumber;
    if (!useSlotsOnBothSides) {
        const mainExtrusionBBox = Utils.getAABBox(mainExtrusion);
        availableSides.sort((firstSide, secondSide) => compareFunctionForSidesOfApplyingZeroDegreesCentralConnector(firstSide, secondSide, mainExtrusionBBox, fastenerPrototypes));
    }
    const sidesToVisualize = useSlotsOnBothSides || fastenerPrototypes.length > 1 ? availableSides : [availableSides[0]];
    sidesToVisualize.forEach((side) => {
        side.slotsOnConnectedExtrusion.forEach((slotDataOnConnectedExtrusion) => {
            const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotDataOnConnectedExtrusion.slot.slotNumber);
            if (!fastenerPrototype) {
                return;
            }
            const clonedFastener = fastenerPrototype.clone();
            visualizeCentralConnectorForOnePairOfSlots(side.slotOnMainExtrusion, slotDataOnConnectedExtrusion.slot, clonedFastener, slotDataOnConnectedExtrusion.nearestSnappedSnappingPoint);
            fasteners.push(clonedFastener);
            slotsOnConnectedExtrusionForGroupA.push(slotDataOnConnectedExtrusion.slot);
        });
    });
    return {
        fasteners,
        slotsOnConnectedExtrusionForGroupA,
    };
}
exports.visualizeZeroDegreesConnector = visualizeZeroDegreesConnector;
function getFastenerBySlotNumber(fastenerPrototypes, slotNumber, distanceToSnappingPoint) {
    const fastenerPrototype = fastenerPrototypes.find((fastener) => {
        const hasDistanceToSnappingPoint = fastener.distanceToTheEdge !== undefined && distanceToSnappingPoint !== undefined;
        return (fastener.slotNumber === slotNumber &&
            (!hasDistanceToSnappingPoint || (0, utils_3d_1.areEqual)(fastener.distanceToTheEdge, distanceToSnappingPoint)));
    });
    if (fastenerPrototype) {
        return fastenerPrototype;
    }
    if (fastenerPrototypes.length === 1) {
        return fastenerPrototypes.at(0);
    }
    return null;
}
function visualizeScrewCombinationFasteners(availableSlotsWithSnappingPoints, fastenerPrototypes) {
    const fasteners = [];
    const slotsOnConnectedExtrusionForGroupA = [];
    availableSlotsWithSnappingPoints.forEach(([slotOnMainExtrusion, slotsOnConnectedExtrusion, snappingPointOnConnectedExtrusion]) => {
        const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotOnMainExtrusion.slotNumber);
        if (!fastenerPrototype ||
            fastenerPrototype.fastenerType !== types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREW_COMBINATION_FASTENERS) {
            return;
        }
        const fastener = fastenerPrototype.clone();
        visualizeScrewCombinationFastenerForOnePairOfSlots(slotOnMainExtrusion, snappingPointOnConnectedExtrusion, fastener);
        slotsOnConnectedExtrusionForGroupA.push(slotsOnConnectedExtrusion);
        fasteners.push(fastener);
    });
    return {
        fasteners,
        slotsOnConnectedExtrusionForGroupA,
    };
}
exports.visualizeScrewCombinationFasteners = visualizeScrewCombinationFasteners;
function tryToVisualizeFastenersForPerpendicularExtrusions(firstExtrusion, secondExtrusion, fastenerPrototypes) {
    var _a, _b, _c;
    if (fastenerPrototypes.some((fastenerPrototype) => { var _a; return types_1.FASTENER_TYPES_OF_GROUP_A.includes((_a = fastenerPrototype.fastenerType) !== null && _a !== void 0 ? _a : ''); })) {
        const availableSlots = validateIfFastenersOfAGroupCanBePlaced(firstExtrusion, secondExtrusion);
        if (!availableSlots.length) {
            return null;
        }
        return visualizeFastenerForAandDoubleAnchorGroupsAndPlateConnectors(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes);
    }
    if (fastenerPrototypes.some((fastenerPrototype) => { var _a; return types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP.includes((_a = fastenerPrototype.fastenerType) !== null && _a !== void 0 ? _a : ''); }) ||
        fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.PLATE_CONNECTOR)) {
        const availableSlots = fastenerPrototypes[0].fastenerType === types_1.FASTENER_TYPES.PLATE_CONNECTOR
            ? validateIfPlateConnectorsCanBePlaced(firstExtrusion, secondExtrusion)
            : validateIfFastenersOfDoubleAnchorGroupCanBePlaced(firstExtrusion, secondExtrusion);
        let mainExtrusion = firstExtrusion;
        let connectedExtrusion = secondExtrusion;
        if (((_b = (_a = availableSlots[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.objectUUID) === connectedExtrusion.uuid) {
            const temp = mainExtrusion;
            mainExtrusion = connectedExtrusion;
            connectedExtrusion = temp;
        }
        const requiredFastenerSize = Utils.getExtrusionSideHeightConnectedByEnd(connectedExtrusion, mainExtrusion);
        if (!availableSlots.length) {
            return null;
        }
        if (!requiredFastenerSize ||
            (fastenerPrototypes.length === 1 &&
                Utils.areNotEqual(requiredFastenerSize, (_c = fastenerPrototypes[0].fastenerSize) !== null && _c !== void 0 ? _c : 0, consts_1.consts.THREE_FLOAT_EPSILON))) {
            return null;
        }
        return visualizeFastenerForAandDoubleAnchorGroupsAndPlateConnectors(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes);
    }
    if (fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR)) {
        const availableSidesOfConnectedExtrusion = validateIfZeroDegreeCentralConnectorsCanBePlace(firstExtrusion, secondExtrusion);
        if (!availableSidesOfConnectedExtrusion.length) {
            return null;
        }
        return visualizeZeroDegreesConnector(firstExtrusion, secondExtrusion, availableSidesOfConnectedExtrusion, fastenerPrototypes);
    }
    if (fastenerPrototypes.some((fastenerPrototype) => { var _a; return types_1.FASTENER_TYPES_OF_SCREWS_GROUP.includes((_a = fastenerPrototype.fastenerType) !== null && _a !== void 0 ? _a : ''); })) {
        const availableSlots = validateIfFastenersOfScrewGroupCanBePlaced(firstExtrusion, secondExtrusion);
        if (!availableSlots.length) {
            return null;
        }
        return visualizeFastenerForEndGroup(firstExtrusion, secondExtrusion, availableSlots, false, fastenerPrototypes);
    }
    if (fastenerPrototypes.some((fastenerPrototype) => { var _a; return types_1.FASTENER_TYPES_OF_END_GROUP.includes((_a = fastenerPrototype.fastenerType) !== null && _a !== void 0 ? _a : ''); })) {
        const { availableSlots, isValidDoubleFastener } = validateIfFastenersForEndGroupCanBePlaced(firstExtrusion, secondExtrusion);
        if (!availableSlots.length) {
            return null;
        }
        return visualizeFastenerForEndGroup(firstExtrusion, secondExtrusion, availableSlots, isValidDoubleFastener, fastenerPrototypes);
    }
    if (fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREWS)) {
        const availableSlots = validateIfSocketHeadCapScrewsCanBePlaced(firstExtrusion, secondExtrusion);
        if (!availableSlots.length) {
            return null;
        }
        return visualizeSocketHeadCapScrews(firstExtrusion, secondExtrusion, availableSlots, fastenerPrototypes);
    }
    return null;
}
exports.tryToVisualizeFastenersForPerpendicularExtrusions = tryToVisualizeFastenersForPerpendicularExtrusions;
function tryToVisualizeFastenersForEndToEndConnection(firstExtrusion, secondExtrusion, fastenerPrototypes, numberOfSnappingPoints) {
    var _a, _b, _c;
    const availableSlots = validateIfEndToEndFastenersCanBePlaced(firstExtrusion, secondExtrusion);
    if (!availableSlots.length) {
        return null;
    }
    let pairsOfSlots = null;
    const priorAxesArray = Utils.getPriorAxesForEndToEndFasteners(firstExtrusion.directionNormal);
    const [firstGroup, secondGroup] = Utils.groupEndToEndAvailableSlotsIntoTwoPerpendicularGroups(availableSlots);
    const excludeCollisionUUIDs = new Set([firstExtrusion.uuid, secondExtrusion.uuid]);
    if (numberOfSnappingPoints === 1) {
        let foundFirstPair = false;
        let visualization = null;
        for (const priorAxis of priorAxesArray) {
            const pairOfSlots = (_a = availableSlots.filter((slot) => Utils.areVectorsEqual(slot[0].normal, priorAxis, consts_1.consts.THREE_FLOAT_EPSILON))) === null || _a === void 0 ? void 0 : _a[0];
            if (pairOfSlots) {
                if (!foundFirstPair) {
                    foundFirstPair = true;
                }
                // TODO: Recheck for flip
                const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, pairOfSlots[1].slotNumber);
                if (!fastenerPrototype) {
                    continue;
                }
                const visualizationResult = visualizeEndToEndFastenerForOnePairOfSlots(pairOfSlots[0], pairOfSlots[1], fastenerPrototype);
                if (!visualizationResult) {
                    continue;
                }
                Viewer_1.default.instance.getScene().add(fastenerPrototype);
                const collided = Viewer_1.default.instance.collisionProcessor.testCollisions(fastenerPrototype, Utils.getOBB(fastenerPrototype), {
                    excludeIDs: excludeCollisionUUIDs,
                    firstFoundCollisionOnly: true,
                });
                fastenerPrototype.removeFromParent();
                if (collided.result) {
                    continue;
                }
                if (!visualization) {
                    visualization = visualizationResult;
                }
                else {
                    const { fasteners, slotNumbersOnMainExtrusionForEndToEnd, slotNumbersOnConnectedExtrusionForEndToEnd } = visualizationResult;
                    visualization.fasteners.push(...fasteners);
                    (_b = visualization.slotNumbersOnMainExtrusionForEndToEnd) === null || _b === void 0 ? void 0 : _b.push(...(slotNumbersOnMainExtrusionForEndToEnd !== null && slotNumbersOnMainExtrusionForEndToEnd !== void 0 ? slotNumbersOnMainExtrusionForEndToEnd : []));
                    (_c = visualization.slotNumbersOnConnectedExtrusionForEndToEnd) === null || _c === void 0 ? void 0 : _c.push(...(slotNumbersOnConnectedExtrusionForEndToEnd !== null && slotNumbersOnConnectedExtrusionForEndToEnd !== void 0 ? slotNumbersOnConnectedExtrusionForEndToEnd : []));
                }
                if (visualization.fasteners.length >= fastenerPrototypes.length) {
                    break;
                }
            }
        }
        return visualization;
    }
    const [numberOfCollidedFastenersOnFirstGroup, numberOfCollidedFastenersOnSecondGroup] = [firstGroup, secondGroup].map((group) => group === null || group === void 0 ? void 0 : group.filter(([slotOnMainExtrusion, slotOnConnectedExtrusion]) => {
        const fastenerPrototype = getFastenerBySlotNumber(fastenerPrototypes, slotOnConnectedExtrusion.slotNumber);
        if (!fastenerPrototype) {
            return false;
        }
        const visualizationResult = visualizeEndToEndFastenerForOnePairOfSlots(slotOnMainExtrusion, slotOnConnectedExtrusion, fastenerPrototype);
        if (!visualizationResult) {
            return false;
        }
        Viewer_1.default.instance.getScene().add(fastenerPrototype);
        const collided = Viewer_1.default.instance.collisionProcessor.testCollisions(fastenerPrototype, Utils.getOBB(fastenerPrototype), {
            excludeIDs: excludeCollisionUUIDs,
            firstFoundCollisionOnly: true,
        }).result;
        fastenerPrototype.removeFromParent();
        return collided;
    }).length);
    if (firstGroup === undefined || secondGroup === undefined) {
        pairsOfSlots = firstGroup !== null && firstGroup !== void 0 ? firstGroup : secondGroup;
    }
    else if (numberOfCollidedFastenersOnFirstGroup !== numberOfCollidedFastenersOnSecondGroup) {
        pairsOfSlots =
            numberOfCollidedFastenersOnFirstGroup < numberOfCollidedFastenersOnSecondGroup ? firstGroup : secondGroup;
    }
    else {
        pairsOfSlots = firstGroup.length <= secondGroup.length ? firstGroup : secondGroup;
    }
    return visualizeEndToEndFasteners(pairsOfSlots, fastenerPrototypes);
}
exports.tryToVisualizeFastenersForEndToEndConnection = tryToVisualizeFastenersForEndToEndConnection;
function tryToVisualizeFastenersForAngledExtrusions(firstExtrusion, secondExtrusion, fastenerPrototypes) {
    if (fastenerPrototypes.some((fastenerPrototype) => fastenerPrototype.fastenerType === types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREW_COMBINATION_FASTENERS)) {
        const availableSlotsWithSnappingPoints = validateIfScrewCombinationFastenerCanBePlace(firstExtrusion, secondExtrusion);
        if (!availableSlotsWithSnappingPoints.length) {
            return null;
        }
        return visualizeScrewCombinationFasteners(availableSlotsWithSnappingPoints, fastenerPrototypes);
    }
    return null;
}
exports.tryToVisualizeFastenersForAngledExtrusions = tryToVisualizeFastenersForAngledExtrusions;
function tryToVisualizeGasket(mainObject, connectedObject, gasket) {
    let slotData;
    const slots = connectedObject.getSlots();
    const panelContour = mainObject.getTransformedCutContour();
    if (!(slots === null || slots === void 0 ? void 0 : slots.length) || !panelContour.length) {
        return null;
    }
    slots.forEach((currentSlot) => {
        if (slotData) {
            return;
        }
        panelContour.forEach((currentPoint, pointIndex) => {
            const nextPoint = pointIndex < panelContour.length - 1 ? panelContour[pointIndex + 1] : panelContour[0];
            const gasketLength = tempVector.subVectors(currentPoint, nextPoint).length();
            if (gasketLength < gasket.scale.x || gasketLength < gasket.scale.y) {
                return;
            }
            const slotSurfacePlane = tempPlane.setFromNormalAndCoplanarPoint(currentSlot.normal, currentSlot.surfacePoint);
            const slotDepth = currentSlot.depth;
            if (Utils.areEqual(Math.abs(slotSurfacePlane.distanceToPoint(currentPoint)), slotDepth) &&
                Utils.areEqual(Math.abs(slotSurfacePlane.distanceToPoint(nextPoint)), slotDepth) &&
                (0, PanelInSlotsUtils_1.isGasketInSlot)(currentSlot, currentPoint, nextPoint)) {
                slotData = { points: [currentPoint, nextPoint], slot: currentSlot };
            }
        });
    });
    if (!slotData) {
        return null;
    }
    const gasketSnapping = new GasketInSlotSnapping_1.default(Viewer_1.default.instance, gasket.clone());
    const gaskets = gasketSnapping.snapToInternalSideOfSlot(slotData.slot, mainObject, connectedObject, slotData.points);
    return gaskets.length
        ? {
            fasteners: gaskets,
            slotsOnConnectedExtrusionForGroupA: [],
            slotNumbersOnMainExtrusionWithDistanceToSnappingPoint: [],
            slotNumbersOnMainExtrusionForEndToEnd: [],
            slotNumbersOnConnectedExtrusionForEndToEnd: [],
        }
        : null;
}
exports.tryToVisualizeGasket = tryToVisualizeGasket;
function tryToVisualizeCombinedFasteners(mainObject, connectedObject, connectedItem, connectionType, fastenerPrototypes) {
    const finalFastenersVisualizationResult = {
        fasteners: [],
        slotsOnConnectedExtrusionForGroupA: [],
        slotNumbersOnMainExtrusionWithDistanceToSnappingPoint: [],
        slotNumbersOnMainExtrusionForEndToEnd: [],
        slotNumbersOnConnectedExtrusionForEndToEnd: [],
    };
    // TODO it would be great to review and refactor this
    fastenerPrototypes.forEach((fastenerPrototype) => {
        var _a;
        let fastenersVisualizationResult;
        switch (connectionType) {
            case types_1.CONNECTION_TYPE.PERPENDICULAR:
                fastenersVisualizationResult = tryToVisualizeFastenersForPerpendicularExtrusions(mainObject, connectedObject, [
                    fastenerPrototype,
                    fastenerPrototype,
                ]);
                break;
            // to verify
            case types_1.CONNECTION_TYPE.ANGLED:
                fastenersVisualizationResult = tryToVisualizeFastenersForAngledExtrusions(mainObject, connectedObject, [
                    fastenerPrototype,
                    fastenerPrototype,
                ]);
                break;
            case types_1.CONNECTION_TYPE.END_TO_END:
                fastenersVisualizationResult = tryToVisualizeFastenersForEndToEndConnection(mainObject, connectedObject, [fastenerPrototype, fastenerPrototype], (_a = connectedItem.numberOfSnappedSnappingPoints) !== null && _a !== void 0 ? _a : 0);
                break;
            default:
                break;
        }
        if (fastenersVisualizationResult) {
            const { fasteners, slotsOnConnectedExtrusionForGroupA, slotNumbersOnMainExtrusionWithDistanceToSnappingPoint, slotNumbersOnMainExtrusionForEndToEnd, slotNumbersOnConnectedExtrusionForEndToEnd, } = fastenersVisualizationResult;
            finalFastenersVisualizationResult.fasteners.push(...(fasteners !== null && fasteners !== void 0 ? fasteners : []));
            finalFastenersVisualizationResult.slotsOnConnectedExtrusionForGroupA.push(...(slotsOnConnectedExtrusionForGroupA !== null && slotsOnConnectedExtrusionForGroupA !== void 0 ? slotsOnConnectedExtrusionForGroupA : []));
            finalFastenersVisualizationResult.slotNumbersOnMainExtrusionWithDistanceToSnappingPoint.push(...(slotNumbersOnMainExtrusionWithDistanceToSnappingPoint !== null && slotNumbersOnMainExtrusionWithDistanceToSnappingPoint !== void 0 ? slotNumbersOnMainExtrusionWithDistanceToSnappingPoint : []));
            finalFastenersVisualizationResult.slotNumbersOnMainExtrusionForEndToEnd.push(...(slotNumbersOnMainExtrusionForEndToEnd !== null && slotNumbersOnMainExtrusionForEndToEnd !== void 0 ? slotNumbersOnMainExtrusionForEndToEnd : []));
            finalFastenersVisualizationResult.slotNumbersOnConnectedExtrusionForEndToEnd.push(...(slotNumbersOnConnectedExtrusionForEndToEnd !== null && slotNumbersOnConnectedExtrusionForEndToEnd !== void 0 ? slotNumbersOnConnectedExtrusionForEndToEnd : []));
        }
    });
    return finalFastenersVisualizationResult;
}
exports.tryToVisualizeCombinedFasteners = tryToVisualizeCombinedFasteners;
function tryToVisualizeFasteners(mainObject, connectedObject, mainItem, connectedItem, connectionType, fastenerPrototype) {
    var _a, _b;
    // TODO: remove when gasket visualisation will be ready
    if (typeof fastenerPrototype.checkIfAllVisualizationDataPresent !== 'function' ||
        !fastenerPrototype.checkIfAllVisualizationDataPresent()) {
        return null;
    }
    let fastenersVisualizationResult = null;
    fastenerPrototype.slotNumber = undefined;
    switch (connectionType) {
        case types_1.CONNECTION_TYPE.PERPENDICULAR:
            fastenersVisualizationResult = tryToVisualizeFastenersForPerpendicularExtrusions(mainObject, connectedObject, [
                fastenerPrototype,
            ]);
            break;
        case types_1.CONNECTION_TYPE.ANGLED:
            fastenersVisualizationResult = tryToVisualizeFastenersForAngledExtrusions(mainObject, connectedObject, [
                fastenerPrototype,
            ]);
            break;
        case types_1.CONNECTION_TYPE.COMPONENT:
            fastenersVisualizationResult = tryToVisualizeFastenersForComponentConnection(mainObject, connectedObject, mainItem, connectedItem, fastenerPrototype);
            break;
        case types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SIDE:
            fastenersVisualizationResult = tryToVisualizeFastenersForPanelToExtrusionSideConnection(mainObject, connectedObject, (_a = connectedItem.slotNumbers) !== null && _a !== void 0 ? _a : [], fastenerPrototype);
            break;
        case types_1.CONNECTION_TYPE.END_TO_END:
            fastenersVisualizationResult = tryToVisualizeFastenersForEndToEndConnection(mainObject, connectedObject, [fastenerPrototype], (_b = connectedItem.numberOfSnappedSnappingPoints) !== null && _b !== void 0 ? _b : 0);
            break;
        case types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT:
            fastenersVisualizationResult = tryToVisualizeGasket(mainObject, connectedObject, fastenerPrototype);
            break;
        default:
            break;
    }
    return fastenersVisualizationResult;
}
exports.tryToVisualizeFasteners = tryToVisualizeFasteners;
function addSphereToConnection(mainObject, connectedObject, connectionObject, visible = false) {
    var _a;
    if (!connectionObject.getSphere()) {
        connectionObject.addSphere(createConnectionSphere(consts_1.consts.DEFAULT_CONNECTION_SPHERE_RADIUS, (_a = Utils.computeSnapPosition(mainObject, connectedObject)) !== null && _a !== void 0 ? _a : new three_1.Vector3()));
    }
    if (visible) {
        connectionObject.makeSphereVisible();
    }
}
exports.addSphereToConnection = addSphereToConnection;
function isObjectSnapped(object, viewer) {
    return Utils.getObjectsNearby(object, viewer).some((objectNearby) => areObjectsSnapped(objectNearby, object));
}
exports.isObjectSnapped = isObjectSnapped;
function getApplicableFastenerTypesForPerpendicularExtrusions(firstExtrusion, secondExtrusion) {
    var _a;
    let result = [];
    if (((_a = validateIfFastenersOfAGroupCanBePlaced(firstExtrusion, secondExtrusion)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        result.push(...types_1.FASTENER_TYPES_OF_GROUP_A);
    }
    if (validateIfZeroDegreeCentralConnectorsCanBePlace(firstExtrusion, secondExtrusion).length > 0) {
        result.push(types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR);
    }
    const { availableSlots, isValidDoubleFastener } = validateIfFastenersForEndGroupCanBePlaced(firstExtrusion, secondExtrusion);
    if (availableSlots.length > 0) {
        result.push(...types_1.FASTENER_TYPES_OF_END_GROUP);
        if (!isValidDoubleFastener) {
            result = result.filter((fastenerType) => fastenerType !== types_1.FASTENER_TYPES.DOUBLE_END_FASTENERS);
        }
    }
    if (validateIfFastenersOfScrewGroupCanBePlaced(firstExtrusion, secondExtrusion).length > 0) {
        result.push(...types_1.FASTENER_TYPES_OF_SCREWS_GROUP);
    }
    if (validateIfSocketHeadCapScrewsCanBePlaced(firstExtrusion, secondExtrusion).length > 0) {
        result.push(types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREWS);
    }
    if (validateIfFastenersOfDoubleAnchorGroupCanBePlaced(firstExtrusion, secondExtrusion).length > 0) {
        result.push(...types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP);
    }
    if (validateIfPlateConnectorsCanBePlaced(firstExtrusion, secondExtrusion).length > 0) {
        result.push(types_1.FASTENER_TYPES.PLATE_CONNECTOR);
    }
    return result;
}
exports.getApplicableFastenerTypesForPerpendicularExtrusions = getApplicableFastenerTypesForPerpendicularExtrusions;
function getApplicableFastenerTypesForAngledExtrusions(firstExtrusion, secondExtrusion) {
    const result = [];
    if (validateIfScrewCombinationFastenerCanBePlace(firstExtrusion, secondExtrusion).length) {
        result.push(types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREW_COMBINATION_FASTENERS);
    }
    return result;
}
exports.getApplicableFastenerTypesForAngledExtrusions = getApplicableFastenerTypesForAngledExtrusions;
function getApplicableFastenerTypesForEndToEndExtrusions(firstExtrusion, secondExtrusion) {
    const result = [];
    if (validateIfEndToEndFastenersCanBePlaced(firstExtrusion, secondExtrusion).length) {
        result.push(...types_1.FASTENER_TYPES_OF_END_TO_END_GROUP);
    }
    return result;
}
exports.getApplicableFastenerTypesForEndToEndExtrusions = getApplicableFastenerTypesForEndToEndExtrusions;
function getApplicableFastenerTypes(firstObject, secondObject, connectionType) {
    if (!connectionType) {
        const snapData = getSnappingData(firstObject, secondObject);
        if (!snapData.snapped) {
            return [];
        }
        connectionType = ConnectionManager_3d_1.default.getConnectionType(snapData.mountedObject, snapData.neighborObject);
    }
    const isExtrusionToExtrusion = Utils.isExtrusion(firstObject) && Utils.isExtrusion(secondObject);
    if (isExtrusionToExtrusion && connectionType === types_1.CONNECTION_TYPE.PERPENDICULAR) {
        return getApplicableFastenerTypesForPerpendicularExtrusions(firstObject, secondObject);
    }
    if (isExtrusionToExtrusion && connectionType === types_1.CONNECTION_TYPE.ANGLED) {
        return getApplicableFastenerTypesForAngledExtrusions(firstObject, secondObject);
    }
    if (isExtrusionToExtrusion && connectionType === types_1.CONNECTION_TYPE.END_TO_END) {
        return getApplicableFastenerTypesForEndToEndExtrusions(firstObject, secondObject);
    }
    return [];
}
exports.getApplicableFastenerTypes = getApplicableFastenerTypes;
/**
 *
 * @param connectedObject - item connected by inbound snapping points
 * @param mainObject
 *
 * @returns true if connected object was transformed and false in other cases
 */
function onBeforeRemoveOrHidePlateConnector(fastener, mainExtrusion, connectedExtrusion) {
    if (fastener.fastenerType !== types_1.FASTENER_TYPES.PLATE_CONNECTOR || connectedExtrusion.type !== types_1.ITEM_TYPE.EXTRUSION) {
        return false;
    }
    const fastenerBbox = Utils.getAABBox(fastener);
    const distanceFromEndFaceAToFastener = fastenerBbox.distanceToPoint(connectedExtrusion.position);
    const endFaceB = connectedExtrusion.position
        .clone()
        .add(tempVector.copy(connectedExtrusion.directionNormal).multiplyScalar(connectedExtrusion.getLength()));
    const distanceFromEndFaceBToFastener = fastenerBbox.distanceToPoint(endFaceB);
    const isFastenerConnectedFromEndFaceA = distanceFromEndFaceAToFastener < distanceFromEndFaceBToFastener;
    const fastenerBboxSize = fastenerBbox.getSize(new three_1.Vector3());
    const fastenerWidth = Math.abs(fastenerBboxSize.dot(connectedExtrusion.directionNormal));
    if (isFastenerConnectedFromEndFaceA) {
        connectedExtrusion.translate(tempVector.copy(connectedExtrusion.directionNormal).negate().setLength(fastenerWidth));
    }
    connectedExtrusion.setScaleZ(connectedExtrusion.scale.z + fastenerWidth);
    connectedExtrusion.originalPosition = connectedExtrusion.position.clone();
    connectedExtrusion.originalPanelSize = connectedExtrusion.getSize();
    return true;
}
exports.onBeforeRemoveOrHidePlateConnector = onBeforeRemoveOrHidePlateConnector;
/**
 *
 * @param connectedExtrusion - item connected by inbound snapping points
 * @param mainExtrusion
 *
 * @returns true if connected object was transformed and false in other cases
 */
function onAfterAddOrShowPlateConnector(fastener, mainExtrusion, connectedExtrusion) {
    var _a, _b, _c;
    if (fastener.fastenerType !== types_1.FASTENER_TYPES.PLATE_CONNECTOR ||
        connectedExtrusion.type !== types_1.ITEM_TYPE.EXTRUSION ||
        mainExtrusion.type !== types_1.ITEM_TYPE.EXTRUSION) {
        return false;
    }
    const snappedSnappingPoint = findSnappingToSlots((_a = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = mainExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'findBoth').snappingPoints[0];
    if (!snappedSnappingPoint) {
        return false;
    }
    const fastenerBboxSize = Utils.getAABBoxSize(fastener);
    const fastenerWidth = Math.abs(fastenerBboxSize.dot(connectedExtrusion.directionNormal));
    if (Utils.areEqual(snappedSnappingPoint.dot(connectedExtrusion.directionNormal), connectedExtrusion.position.dot(connectedExtrusion.directionNormal))) {
        connectedExtrusion.originalPosition = connectedExtrusion.position.clone();
        connectedExtrusion.translate(tempVector.copy(connectedExtrusion.directionNormal).setLength(fastenerWidth));
    }
    (_c = connectedExtrusion.originalPanelSize) !== null && _c !== void 0 ? _c : (connectedExtrusion.originalPanelSize = connectedExtrusion.getSize());
    connectedExtrusion.setScaleZ(connectedExtrusion.scale.z - fastenerWidth);
    return true;
}
exports.onAfterAddOrShowPlateConnector = onAfterAddOrShowPlateConnector;
function getSlotsOnExtrusionByFastenerPosition(mainExtrusion, connectedExtrusion, fastener) {
    var _a, _b;
    const tempBox3 = new three_1.Box3();
    const tempSizeVector = new three_1.Vector3();
    let maxIntersectionOnConnectedExtrusionSlot = -Infinity;
    let maxIntersectionOnMainExtrusionSlot = -Infinity;
    let slotOnMainExtrusion;
    let slotOnConnectedExtrusion;
    ((_a = mainExtrusion.getSlots()) !== null && _a !== void 0 ? _a : [])
        .map((slot) => ({ isMain: true, slot }))
        .concat(((_b = connectedExtrusion.getSlots()) !== null && _b !== void 0 ? _b : []).map((slot) => ({ isMain: false, slot })))
        .forEach(({ isMain, slot }) => {
        tempBox3.setFromPoints(slot.points).expandByPoint(slot.surfacePoint);
        const fastenerBox3 = Utils.getAABBox(fastener);
        tempBox3.intersect(fastenerBox3);
        tempBox3.getSize(tempSizeVector);
        const intersectionVolume = tempSizeVector.x * tempSizeVector.y * tempSizeVector.z;
        if (isMain &&
            Number.isFinite(intersectionVolume) &&
            intersectionVolume > 0 &&
            intersectionVolume > maxIntersectionOnMainExtrusionSlot) {
            maxIntersectionOnMainExtrusionSlot = intersectionVolume;
            slotOnMainExtrusion = slot;
        }
        else if (Number.isFinite(intersectionVolume) &&
            intersectionVolume > 0 &&
            intersectionVolume > maxIntersectionOnConnectedExtrusionSlot) {
            maxIntersectionOnConnectedExtrusionSlot = intersectionVolume;
            slotOnConnectedExtrusion = slot;
        }
    });
    return slotOnMainExtrusion && slotOnConnectedExtrusion ? [slotOnMainExtrusion, slotOnConnectedExtrusion] : null;
}
exports.getSlotsOnExtrusionByFastenerPosition = getSlotsOnExtrusionByFastenerPosition;
function checkIfEndToEndFastenersCanBeFlipped(availableSlots, mainExtrusion, connectedExtrusion) {
    var _a, _b;
    const numberOfSnappingPoints = findFittedSnappingPoints((_a = mainExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = connectedExtrusion.getInboundSnappingPointsRaw()) !== null && _b !== void 0 ? _b : [], 'findSnappingPoints').points.length;
    let result = false;
    if (numberOfSnappingPoints > 1) {
        const priorAxes = Utils.getPriorAxesForEndToEndFasteners(mainExtrusion.directionNormal);
        const numberOfSlotsByAxis = new Map(priorAxes.map((axis) => [Utils.vecToLetter(axis), 0]));
        availableSlots.forEach(([availableSlot]) => {
            const axisIndex = Utils.vecToLetter(availableSlot.normal);
            const currentNumber = numberOfSlotsByAxis.get(axisIndex);
            if (currentNumber !== undefined) {
                numberOfSlotsByAxis.set(axisIndex, currentNumber + 1);
            }
        });
        const numberOfSlots = Array.from(numberOfSlotsByAxis.values()).filter((number) => number !== 0);
        const extrusionSideCount = 4;
        result =
            numberOfSlots.length === extrusionSideCount &&
                numberOfSlots.every((oneSideNumberOfSlots) => oneSideNumberOfSlots === numberOfSlots[0]);
    }
    else if (numberOfSnappingPoints === 1) {
        result = availableSlots.length > 1;
    }
    return result;
}
exports.checkIfEndToEndFastenersCanBeFlipped = checkIfEndToEndFastenersCanBeFlipped;
function checkIfSimilarFastenersCanBeFlipped(fasteners, mainObject, connectedObject) {
    var _a, _b;
    if (!fasteners.length) {
        return false;
    }
    const fastenerType = (_b = (_a = fasteners[0]) === null || _a === void 0 ? void 0 : _a.fastenerType) !== null && _b !== void 0 ? _b : '';
    if ([...types_1.FASTENER_TYPES_OF_GROUP_A, types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR].includes(fastenerType)) {
        let result = false;
        const normalOfFirstFastener = fasteners[0].directionNormal;
        result = fasteners.every((fastener) => Utils.areVectorsEqual(fastener.directionNormal, normalOfFirstFastener));
        if (result && fastenerType === types_1.FASTENER_TYPES.INNER_CONNECTOR) {
            const slotResult = getSlotsOnExtrusionByFastenerPosition(mainObject, connectedObject, fasteners[0]);
            if (!slotResult) {
                return false;
            }
            const [slotOnMainExtrusion, slotOnConnectedExtrusion] = slotResult;
            const oppositeSlot = Utils.getOppositeSlot(connectedObject, slotOnConnectedExtrusion);
            if (!oppositeSlot) {
                return false;
            }
            const fastenerClone = fasteners[0].clone();
            visualizeInnerConnectorForOnePairOfSlots(slotOnMainExtrusion, oppositeSlot, fastenerClone);
            return checkIfInnerConnectorAlignedByBBoxToMainExtrusion(Utils.getAABBox(fastenerClone), Utils.getAABBox(mainObject), connectedObject.directionNormal);
        }
        return true;
    }
    if (types_1.FASTENER_TYPES_OF_END_TO_END_GROUP.includes(fastenerType)) {
        return checkIfEndToEndFastenersCanBeFlipped(validateIfEndToEndFastenersCanBePlaced(mainObject, connectedObject), mainObject, connectedObject);
    }
    return false;
}
exports.checkIfSimilarFastenersCanBeFlipped = checkIfSimilarFastenersCanBeFlipped;
function checkIfFastenersInConnectionCanBeFlipped(connectionObject, fastenerItemNumber) {
    var _a, _b, _c, _d, _e, _f;
    // There is no error, main object in connection are connected object in terms in fastener visualization
    // But this is need to be fixed later
    const connectedObject = Viewer_1.default.instance.getObjectById((_c = (_b = (_a = connectionObject.getConnectionItems()) === null || _a === void 0 ? void 0 : _a.mainItem) === null || _b === void 0 ? void 0 : _b.uuid) !== null && _c !== void 0 ? _c : '');
    const mainObject = Viewer_1.default.instance.getObjectById((_f = (_e = (_d = connectionObject.getConnectionItems()) === null || _d === void 0 ? void 0 : _d.connectedItem) === null || _e === void 0 ? void 0 : _e.uuid) !== null && _f !== void 0 ? _f : '');
    if (!connectedObject || !mainObject) {
        return false;
    }
    return checkIfSimilarFastenersCanBeFlipped(connectionObject.getFasteners().filter((fastener) => fastener.partDetails.itemNumber === fastenerItemNumber), mainObject, connectedObject);
}
exports.checkIfFastenersInConnectionCanBeFlipped = checkIfFastenersInConnectionCanBeFlipped;
function getNextFlipSlotsForEndToEndFasteners(availableSlots, priorAxesArray, currentSlotOnMainExtrusion) {
    var _a, _b;
    if (availableSlots.length <= 1) {
        return null;
    }
    const currentSlotNormal = currentSlotOnMainExtrusion.normal;
    const currentSlotOrigin = currentSlotOnMainExtrusion.origin;
    const currentAxisIndex = priorAxesArray.findIndex((axis) => {
        return (0, utils_3d_1.areVectorsEqual)(axis, currentSlotNormal);
    });
    if (currentAxisIndex < 0) {
        return null;
    }
    const currentSlotWidthDirection = currentSlotNormal.clone().cross(currentSlotOnMainExtrusion.direction);
    const currentSlotOriginProjection = currentSlotOrigin.dot(currentSlotWidthDirection);
    const currentSlotIndex = availableSlots
        .filter(([availableSlot]) => (0, utils_3d_1.areVectorsEqual)(availableSlot.normal, currentSlotNormal))
        .map(([coplanarSlot]) => coplanarSlot.origin.dot(currentSlotWidthDirection))
        .sort((left, right) => left - right)
        .findIndex((originProjection) => (0, utils_3d_1.areEqual)(originProjection, currentSlotOriginProjection));
    if (currentSlotIndex < 0) {
        return null;
    }
    let result = null;
    for (let index = currentAxisIndex + 1; index <= currentAxisIndex + priorAxesArray.length; index += 1) {
        const nextAxisIndex = index % priorAxesArray.length;
        const nextSlotNormal = priorAxesArray[nextAxisIndex];
        result =
            (_b = (_a = availableSlots
                .filter(([availableSlot]) => (0, utils_3d_1.areVectorsEqual)(availableSlot.normal, nextSlotNormal))
                .map((coplanarSlots) => {
                const [coplanarSlotOnMainExtrusion] = coplanarSlots;
                const coplanarSlotWidthDirection = coplanarSlotOnMainExtrusion.normal
                    .clone()
                    .cross(coplanarSlotOnMainExtrusion.direction);
                const coplanarSlotOriginProjection = coplanarSlotOnMainExtrusion.origin.dot(coplanarSlotWidthDirection);
                return { slots: coplanarSlots, originProjection: coplanarSlotOriginProjection };
            })
                .sort((left, right) => left.originProjection - right.originProjection)[currentSlotIndex]) === null || _a === void 0 ? void 0 : _a.slots) !== null && _b !== void 0 ? _b : null;
        if (result || nextAxisIndex === currentAxisIndex - 1) {
            break;
        }
    }
    return result;
}
function tryToFlipFasteners(mainExtrusion, connectedExtrusion, fastenersToFlip) {
    var _a, _b, _c, _d, _e;
    if (!checkIfSimilarFastenersCanBeFlipped(fastenersToFlip, mainExtrusion, connectedExtrusion)) {
        return null;
    }
    let availableSlotsForAGroup = [];
    let availableSlotsForEndToEndGroup = [];
    let availableSlotsForZeroDegreesCentralConnectors = [];
    if (types_1.FASTENER_TYPES_OF_GROUP_A.includes((_b = (_a = fastenersToFlip[0]) === null || _a === void 0 ? void 0 : _a.fastenerType) !== null && _b !== void 0 ? _b : '')) {
        availableSlotsForAGroup = validateIfFastenersOfAGroupCanBePlaced(mainExtrusion, connectedExtrusion);
    }
    else if (types_1.FASTENER_TYPES_OF_END_TO_END_GROUP.includes((_d = (_c = fastenersToFlip[0]) === null || _c === void 0 ? void 0 : _c.fastenerType) !== null && _d !== void 0 ? _d : '')) {
        availableSlotsForEndToEndGroup = validateIfEndToEndFastenersCanBePlaced(mainExtrusion, connectedExtrusion);
    }
    else if (((_e = fastenersToFlip[0]) === null || _e === void 0 ? void 0 : _e.fastenerType) === types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR) {
        availableSlotsForZeroDegreesCentralConnectors = validateIfZeroDegreeCentralConnectorsCanBePlace(mainExtrusion, connectedExtrusion);
    }
    const flipResults = fastenersToFlip.map((fastener) => {
        var _a, _b, _c, _d;
        const slotsDetectionResult = getSlotsOnExtrusionByFastenerPosition(mainExtrusion, connectedExtrusion, fastener);
        if (!slotsDetectionResult) {
            return null;
        }
        const [slotOnMainExtrusion, slotOnConnectedExtrusion] = slotsDetectionResult;
        const oppositeSlotOnConnectedExtrusion = Utils.getOppositeSlot(connectedExtrusion, slotOnConnectedExtrusion);
        const priorAxesForEndToEndFasteners = Utils.getPriorAxesForEndToEndFasteners(mainExtrusion.directionNormal);
        if (types_1.FASTENER_TYPES_OF_GROUP_A.includes((_a = fastener.fastenerType) !== null && _a !== void 0 ? _a : '')) {
            if (!oppositeSlotOnConnectedExtrusion) {
                return null;
            }
            const isNewPairOfSlotsValid = availableSlotsForAGroup.some(([validSlotOnMainExtrusion, validSlotsOnConnectedExtrusion]) => {
                if (slotOnMainExtrusion.slotNumber !== validSlotOnMainExtrusion.slotNumber) {
                    return false;
                }
                return validSlotsOnConnectedExtrusion.some((validSlotOnConnectedExtrusion) => validSlotOnConnectedExtrusion.slotNumber === oppositeSlotOnConnectedExtrusion.slotNumber);
            });
            if (!isNewPairOfSlotsValid) {
                return null;
            }
            const fastenerClone = fastener.clone();
            const isFastenerVisualized = visualizeGroupAFastenerForOnePairOfSlots(slotOnMainExtrusion, oppositeSlotOnConnectedExtrusion, fastenerClone, connectedExtrusion);
            return isFastenerVisualized
                ? {
                    fasteners: [fastenerClone],
                    slotsOnConnectedExtrusionForGroupA: [oppositeSlotOnConnectedExtrusion],
                }
                : null;
        }
        if (types_1.FASTENER_TYPES_OF_END_TO_END_GROUP.includes((_b = fastener.fastenerType) !== null && _b !== void 0 ? _b : '')) {
            const [nextSlotOnMainExtrusion, nextSlotOnConnectedExtrusion] = (_c = getNextFlipSlotsForEndToEndFasteners(availableSlotsForEndToEndGroup, priorAxesForEndToEndFasteners, slotOnMainExtrusion)) !== null && _c !== void 0 ? _c : [];
            if (!nextSlotOnMainExtrusion || !nextSlotOnConnectedExtrusion) {
                return null;
            }
            const fastenerClone = fastener.clone();
            const isFastenerVisualized = visualizeEndToEndFastenerForOnePairOfSlots(nextSlotOnMainExtrusion, nextSlotOnConnectedExtrusion, fastenerClone);
            return isFastenerVisualized
                ? {
                    fasteners: [fastenerClone],
                    slotNumbersOnMainExtrusionForEndToEnd: [nextSlotOnMainExtrusion.slotNumber],
                    slotNumbersOnConnectedExtrusionForEndToEnd: [nextSlotOnConnectedExtrusion.slotNumber],
                }
                : null;
        }
        if (fastener.fastenerType === types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR) {
            if (!oppositeSlotOnConnectedExtrusion) {
                return null;
            }
            const sideOfNewSlot = availableSlotsForZeroDegreesCentralConnectors.find((side) => {
                var _a, _b, _c;
                return Utils.areVectorsEqual((_c = (_b = (_a = side.slotsOnConnectedExtrusion[0]) === null || _a === void 0 ? void 0 : _a.slot) === null || _b === void 0 ? void 0 : _b.normal) !== null && _c !== void 0 ? _c : tempVector.set(0, 0, 0), oppositeSlotOnConnectedExtrusion.normal);
            });
            const oppositeSlotData = (_d = sideOfNewSlot === null || sideOfNewSlot === void 0 ? void 0 : sideOfNewSlot.slotsOnConnectedExtrusion) === null || _d === void 0 ? void 0 : _d.find(({ slot }) => slot.slotNumber === oppositeSlotOnConnectedExtrusion.slotNumber);
            if (!oppositeSlotData) {
                return null;
            }
            const fastenerClone = fastener.clone();
            visualizeCentralConnectorForOnePairOfSlots(sideOfNewSlot.slotOnMainExtrusion, oppositeSlotData.slot, fastenerClone, oppositeSlotData.nearestSnappedSnappingPoint);
            return {
                fasteners: [fastenerClone],
                slotsOnConnectedExtrusionForGroupA: [oppositeSlotData.slot],
            };
        }
        return null;
    });
    const flipFilteredResults = flipResults.filter((flipResult) => !!flipResult);
    if (!flipFilteredResults.length) {
        return null;
    }
    return flipFilteredResults.reduce((accum, currentValue) => {
        var _a, _b, _c;
        accum.fasteners.push(...currentValue.fasteners);
        if (accum.slotsOnConnectedExtrusionForGroupA) {
            accum.slotsOnConnectedExtrusionForGroupA.push(...((_a = currentValue.slotsOnConnectedExtrusionForGroupA) !== null && _a !== void 0 ? _a : []));
        }
        else if (currentValue.slotsOnConnectedExtrusionForGroupA) {
            accum.slotsOnConnectedExtrusionForGroupA = currentValue.slotsOnConnectedExtrusionForGroupA;
        }
        if (accum.slotNumbersOnConnectedExtrusionForEndToEnd) {
            accum.slotNumbersOnConnectedExtrusionForEndToEnd.push(...((_b = currentValue.slotNumbersOnConnectedExtrusionForEndToEnd) !== null && _b !== void 0 ? _b : []));
        }
        else if (currentValue.slotNumbersOnConnectedExtrusionForEndToEnd) {
            accum.slotNumbersOnConnectedExtrusionForEndToEnd = currentValue.slotNumbersOnConnectedExtrusionForEndToEnd;
        }
        if (accum.slotNumbersOnMainExtrusionForEndToEnd) {
            accum.slotNumbersOnMainExtrusionForEndToEnd.push(...((_c = currentValue.slotNumbersOnMainExtrusionForEndToEnd) !== null && _c !== void 0 ? _c : []));
        }
        else if (currentValue.slotNumbersOnMainExtrusionForEndToEnd) {
            accum.slotNumbersOnMainExtrusionForEndToEnd = currentValue.slotNumbersOnMainExtrusionForEndToEnd;
        }
        return accum;
    }, { fasteners: [] });
}
exports.tryToFlipFasteners = tryToFlipFasteners;
function getConnectionMetadataByFastenersPosition(fasteners, mainExtrusion, connectedExtrusion) {
    const result = { fasteners };
    const slotsOnConnectedExtrusionForSlotA = [];
    const slotNumbersOnMainExtrusionWithDistanceToSnappingPoint = [];
    const slotNumbersOnMainExtrusionForEndToEnd = [];
    const slotNumbersOnConnectedExtrusionForEndToEnd = [];
    fasteners.forEach((fastener) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if ([...types_1.FASTENER_TYPES_OF_GROUP_A, types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR].includes((_a = fastener.fastenerType) !== null && _a !== void 0 ? _a : '') ||
            types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP.includes((_b = fastener.fastenerType) !== null && _b !== void 0 ? _b : '')) {
            const slotsOnExtrusions = getSlotsOnExtrusionByFastenerPosition(mainExtrusion, connectedExtrusion, fastener);
            if (slotsOnExtrusions) {
                const [, slotOnConnectedExtrusion] = slotsOnExtrusions;
                slotsOnConnectedExtrusionForSlotA.push(slotOnConnectedExtrusion);
                if (fastener.fastenerType === types_1.FASTENER_TYPES.DOUBLE_ANCHOR_FASTENER) {
                    const oppositeSlot = Utils.getOppositeSlot(connectedExtrusion, slotOnConnectedExtrusion);
                    if (oppositeSlot) {
                        slotsOnConnectedExtrusionForSlotA.push(oppositeSlot);
                    }
                }
            }
            return;
        }
        if ([...types_1.FASTENER_TYPES_OF_END_GROUP, types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREWS].includes((_c = fastener.fastenerType) !== null && _c !== void 0 ? _c : '')) {
            const connectedExtrusionSnappingPoints = connectedExtrusion.getInboundSnappingPointsRaw();
            const fastenerMasterSnappingPoint = (_d = fastener.getMasterSnappingPoint()) !== null && _d !== void 0 ? _d : (_e = fastener.getInboundSnappingPointsRaw()) === null || _e === void 0 ? void 0 : _e[0];
            if (!connectedExtrusionSnappingPoints || !fastenerMasterSnappingPoint) {
                return;
            }
            const fastenerSnappingPoints = (_f = connectedExtrusionSnappingPoints.filter((point) => Utils.areVectorsEqual(tempVector.copy(point).projectOnPlane(connectedExtrusion.directionNormal), tempVector2.copy(fastenerMasterSnappingPoint).projectOnPlane(connectedExtrusion.directionNormal)))) !== null && _f !== void 0 ? _f : [];
            if (fastenerSnappingPoints.length === 0) {
                return;
            }
            const distanceFromEndFaceAToSnappingPoint = mainExtrusion.directionNormal.dot(tempVector.subVectors(fastenerSnappingPoints[0], mainExtrusion.position));
            const slotOnMainExtrusion = findSnappingToSlots(fastenerSnappingPoints, (_g = mainExtrusion.getSlots()) !== null && _g !== void 0 ? _g : [], 'findSlots').slots[0];
            if (!slotOnMainExtrusion) {
                return;
            }
            slotNumbersOnMainExtrusionWithDistanceToSnappingPoint.push({
                slotNumber: slotOnMainExtrusion.slotNumber,
                distance: distanceFromEndFaceAToSnappingPoint,
            });
            if (fastener.fastenerType === types_1.FASTENER_TYPES.DOUBLE_END_FASTENERS) {
                const nextSnappingPoint = (_h = Utils.getNearestPointInDirection(connectedExtrusionSnappingPoints, fastener.directionNormal.clone().negate(), fastenerSnappingPoints[0])) === null || _h === void 0 ? void 0 : _h.point;
                if (nextSnappingPoint) {
                    const distanceFromEndFaceAToNextSnappingPoint = mainExtrusion.directionNormal.dot(tempVector.subVectors(nextSnappingPoint, mainExtrusion.position));
                    slotNumbersOnMainExtrusionWithDistanceToSnappingPoint.push({
                        slotNumber: slotOnMainExtrusion.slotNumber,
                        distance: distanceFromEndFaceAToNextSnappingPoint,
                    });
                }
            }
            return;
        }
        if (types_1.FASTENER_TYPES_OF_END_TO_END_GROUP.includes((_j = fastener.fastenerType) !== null && _j !== void 0 ? _j : '')) {
            const slotsOnExtrusions = getSlotsOnExtrusionByFastenerPosition(connectedExtrusion, mainExtrusion, fastener);
            if (slotsOnExtrusions) {
                const [slotOnMainExtrusion, slotOnConnectedExtrusion] = slotsOnExtrusions;
                slotNumbersOnConnectedExtrusionForEndToEnd.push(slotOnConnectedExtrusion.slotNumber);
                slotNumbersOnMainExtrusionForEndToEnd.push(slotOnMainExtrusion.slotNumber);
            }
        }
    });
    if (slotsOnConnectedExtrusionForSlotA) {
        result.slotsOnConnectedExtrusionForGroupA = slotsOnConnectedExtrusionForSlotA;
    }
    if (slotNumbersOnMainExtrusionWithDistanceToSnappingPoint) {
        result.slotNumbersOnMainExtrusionWithDistanceToSnappingPoint =
            slotNumbersOnMainExtrusionWithDistanceToSnappingPoint;
    }
    if (slotNumbersOnMainExtrusionForEndToEnd) {
        result.slotNumbersOnMainExtrusionForEndToEnd = slotNumbersOnMainExtrusionForEndToEnd;
    }
    if (slotNumbersOnConnectedExtrusionForEndToEnd) {
        result.slotNumbersOnConnectedExtrusionForEndToEnd = slotNumbersOnConnectedExtrusionForEndToEnd;
    }
    return result;
}
exports.getConnectionMetadataByFastenersPosition = getConnectionMetadataByFastenersPosition;
